<template>
  <div v-if="mScheduleItem">
    <b-overlay :show="showOverlay" rounded="sm" variant="info" opacity="0.4">
      <div class="card-body p-0">
        <!-- <div class="d-flex align-items-center p-0">
          <div class="d-flex flex-column flex-grow-1 mb-2">
            start
          
            123
          </div>
        </div> -->
        <!-- <span class="p-3 m-3">isConcept: {{ isConcept }}</span>
        <span class="p-3 m-3">isReadOnly: {{ isReadOnly }}</span> -->


<!-- <br>
{{mScheduleItem}}
<br><br> -->

        <div class="d-flex align-items-center p-0">
          <div class="d-flex flex-column flex-grow-1 mb-2">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 584 140"
              style="enable-background: new 0 0 584 140"
              xml:space="preserve"
            >
              <g id="Berth">
                <g>
                  <rect
                    x="0.5"
                    y="115.13"
                    class="stV0"
                    width="583"
                    height="9"
                  />
                  <path
                    class="stV0"
                    d="M583,115.63v8H1v-8H583 M584,114.63H0v10h584V114.63L584,114.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M7,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H7z"
                  />
                  <path
                    class="stV1"
                    d="M9,118.63H7c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S9.55,118.63,9,118.63L9,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M27,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H27z"
                  />
                  <path
                    class="stV1"
                    d="M29,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C30,119.08,29.55,118.63,29,118.63L29,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M17,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H17z"
                  />
                  <path
                    class="stV1"
                    d="M19,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C20,119.08,19.55,118.63,19,118.63L19,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M37,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H37z"
                  />
                  <path
                    class="stV1"
                    d="M39,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C40,119.08,39.55,118.63,39,118.63L39,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M57,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H57z"
                  />
                  <path
                    class="stV1"
                    d="M59,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S59.55,118.63,59,118.63L59,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M47,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H47z"
                  />
                  <path
                    class="stV1"
                    d="M49,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S49.55,118.63,49,118.63L49,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M67,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H67z"
                  />
                  <path
                    class="stV1"
                    d="M69,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C70,119.08,69.55,118.63,69,118.63L69,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M87,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H87z"
                  />
                  <path
                    class="stV1"
                    d="M89,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S89.55,118.63,89,118.63L89,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M77,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H77z"
                  />
                  <path
                    class="stV1"
                    d="M79,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S79.55,118.63,79,118.63L79,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M97,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H97z"
                  />
                  <path
                    class="stV1"
                    d="M99,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S99.55,118.63,99,118.63L99,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M117,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H117z"
                  />
                  <path
                    class="stV1"
                    d="M119,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C120,119.08,119.55,118.63,119,118.63L119,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M107,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H107z"
                  />
                  <path
                    class="stV1"
                    d="M109,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C110,119.08,109.55,118.63,109,118.63L109,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M127,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H127z"
                  />
                  <path
                    class="stV1"
                    d="M129,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C130,119.08,129.55,118.63,129,118.63L129,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M147,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H147z"
                  />
                  <path
                    class="stV1"
                    d="M149,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S149.55,118.63,149,118.63L149,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M137,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H137z"
                  />
                  <path
                    class="stV1"
                    d="M139,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S139.55,118.63,139,118.63L139,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M157,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H157z"
                  />
                  <path
                    class="stV1"
                    d="M159,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S159.55,118.63,159,118.63L159,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M177,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H177z"
                  />
                  <path
                    class="stV1"
                    d="M179,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C180,119.08,179.55,118.63,179,118.63L179,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M167,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H167z"
                  />
                  <path
                    class="stV1"
                    d="M169,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C170,119.08,169.55,118.63,169,118.63L169,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M187,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H187z"
                  />
                  <path
                    class="stV1"
                    d="M189,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S189.55,118.63,189,118.63L189,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M207,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H207z"
                  />
                  <path
                    class="stV1"
                    d="M209,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S209.55,118.63,209,118.63L209,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M197,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H197z"
                  />
                  <path
                    class="stV1"
                    d="M199,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S199.55,118.63,199,118.63L199,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M217,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H217z"
                  />
                  <path
                    class="stV1"
                    d="M219,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C220,119.08,219.55,118.63,219,118.63L219,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M237,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H237z"
                  />
                  <path
                    class="stV1"
                    d="M239,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S239.55,118.63,239,118.63L239,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M227,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H227z"
                  />
                  <path
                    class="stV1"
                    d="M229,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S229.55,118.63,229,118.63L229,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M247,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H247z"
                  />
                  <path
                    class="stV1"
                    d="M249,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C250,119.08,249.55,118.63,249,118.63L249,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M267,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H267z"
                  />
                  <path
                    class="stV1"
                    d="M269,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S269.55,118.63,269,118.63L269,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M257,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H257z"
                  />
                  <path
                    class="stV1"
                    d="M259,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S259.55,118.63,259,118.63L259,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M277,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H277z"
                  />
                  <path
                    class="stV1"
                    d="M279,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S279.55,118.63,279,118.63L279,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M297,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H297z"
                  />
                  <path
                    class="stV1"
                    d="M299,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C300,119.08,299.55,118.63,299,118.63L299,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M287,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H287z"
                  />
                  <path
                    class="stV1"
                    d="M289,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C290,119.08,289.55,118.63,289,118.63L289,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M307,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H307z"
                  />
                  <path
                    class="stV1"
                    d="M309,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S309.55,118.63,309,118.63L309,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M327,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H327z"
                  />
                  <path
                    class="stV1"
                    d="M329,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S329.55,118.63,329,118.63L329,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M317,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H317z"
                  />
                  <path
                    class="stV1"
                    d="M319,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S319.55,118.63,319,118.63L319,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M337,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H337z"
                  />
                  <path
                    class="stV1"
                    d="M339,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C340,119.08,339.55,118.63,339,118.63L339,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M357,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H357z"
                  />
                  <path
                    class="stV1"
                    d="M359,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S359.55,118.63,359,118.63L359,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M347,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H347z"
                  />
                  <path
                    class="stV1"
                    d="M349,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S349.55,118.63,349,118.63L349,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M367,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H367z"
                  />
                  <path
                    class="stV1"
                    d="M369,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S369.55,118.63,369,118.63L369,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M387,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H387z"
                  />
                  <path
                    class="stV1"
                    d="M389,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S389.55,118.63,389,118.63L389,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M377,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H377z"
                  />
                  <path
                    class="stV1"
                    d="M379,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S379.55,118.63,379,118.63L379,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M397,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H397z"
                  />
                  <path
                    class="stV1"
                    d="M399,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C400,119.08,399.55,118.63,399,118.63L399,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M417,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H417z"
                  />
                  <path
                    class="stV1"
                    d="M419,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S419.55,118.63,419,118.63L419,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M407,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H407z"
                  />
                  <path
                    class="stV1"
                    d="M409,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S409.55,118.63,409,118.63L409,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M427,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H427z"
                  />
                  <path
                    class="stV1"
                    d="M429,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S429.55,118.63,429,118.63L429,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M447,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H447z"
                  />
                  <path
                    class="stV1"
                    d="M449,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S449.55,118.63,449,118.63L449,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M437,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H437z"
                  />
                  <path
                    class="stV1"
                    d="M439,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S439.55,118.63,439,118.63L439,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M457,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H457z"
                  />
                  <path
                    class="stV1"
                    d="M459,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S459.55,118.63,459,118.63L459,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M477,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H477z"
                  />
                  <path
                    class="stV1"
                    d="M479,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S479.55,118.63,479,118.63L479,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M467,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H467z"
                  />
                  <path
                    class="stV1"
                    d="M469,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S469.55,118.63,469,118.63L469,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M497,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H497z"
                  />
                  <path
                    class="stV1"
                    d="M499,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S499.55,118.63,499,118.63L499,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M487,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H487z"
                  />
                  <path
                    class="stV1"
                    d="M489,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S489.55,118.63,489,118.63L489,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M507,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H507z"
                  />
                  <path
                    class="stV1"
                    d="M509,118.63h-2c-0.55,0-1,0.45-1,1v0c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v0
			C510,119.08,509.55,118.63,509,118.63L509,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M527,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H527z"
                  />
                  <path
                    class="stV1"
                    d="M529,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S529.55,118.63,529,118.63L529,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M517,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H517z"
                  />
                  <path
                    class="stV1"
                    d="M519,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S519.55,118.63,519,118.63L519,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M537,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H537z"
                  />
                  <path
                    class="stV1"
                    d="M539,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S539.55,118.63,539,118.63L539,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M557,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H557z"
                  />
                  <path
                    class="stV1"
                    d="M559,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S559.55,118.63,559,118.63L559,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M547,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H547z"
                  />
                  <path
                    class="stV1"
                    d="M549,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S549.55,118.63,549,118.63L549,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M567,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H567z"
                  />
                  <path
                    class="stV1"
                    d="M569,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S569.55,118.63,569,118.63L569,118.63z"
                  />
                </g>
                <g>
                  <path
                    class="stV1"
                    d="M577,120.13c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h2c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H577z"
                  />
                  <path
                    class="stV1"
                    d="M579,118.63h-2c-0.55,0-1,0.45-1,1s0.45,1,1,1h2c0.55,0,1-0.45,1-1S579.55,118.63,579,118.63L579,118.63z"
                  />
                </g>
              </g>
              <g
                id="Bollards_00000083786782686303614210000000583614927727047306_"
              >
                <g id="Bollards">
                  <g>
                    <path
                      class="stV2"
                      d="M159.81,96h-4.63c-1.6,0-2.9,1.46-2.9,3.25h10.43C162.72,97.46,161.41,96,159.81,96z"
                    />
                  </g>
                  <path
                    class="stV2"
                    d="M150.49,108.36L150.49,108.36c-0.27,0-0.49-0.22-0.49-0.49v-4.65c0-0.27,0.22-0.49,0.49-0.49l0,0
			c0.27,0,0.49,0.22,0.49,0.49v4.65C150.98,108.14,150.76,108.36,150.49,108.36z"
                  />
                  <path
                    class="stV2"
                    d="M164.51,108.37L164.51,108.37c-0.27,0-0.49-0.22-0.49-0.49v-4.65c0-0.27,0.22-0.49,0.49-0.49l0,0
			c0.27,0,0.49,0.22,0.49,0.49v4.65C165,108.15,164.78,108.37,164.51,108.37z"
                  />
                  <g>
                    <path
                      class="stV2"
                      d="M158.29,107.72h-1.61l-2.2,1.27c-0.08,0.04-0.16,0.08-0.24,0.11v3.8h6.52v-3.77
				c-0.07-0.03-0.13-0.06-0.2-0.09L158.29,107.72z"
                    />
                    <path
                      class="stV2"
                      d="M156.71,103.39h1.44l2.26-1.3c0.11-0.06,0.23-0.11,0.34-0.14v-1.62h-6.52v1.66c0.07,0.03,0.13,0.06,0.2,0.09
				L156.71,103.39z"
                    />
                    <path
                      class="stV2"
                      d="M164.02,103.39h-1.34c0,0.52-0.27,1.03-0.75,1.31l-1.17,0.67v0.35l1.29,0.74c0.47,0.27,0.73,0.76,0.74,1.26
				h1.23V103.39z"
                    />
                    <path
                      class="stV2"
                      d="M152.96,106.38l1.28-0.74v-0.25l-1.29-0.74c-0.47-0.27-0.73-0.76-0.74-1.26h-1.23v4.33h1.23
				C152.19,107.19,152.47,106.66,152.96,106.38z"
                    />
                    <polygon
                      class="stV2"
                      points="156.68,107.72 158.29,107.72 157.48,107.26 			"
                    />
                    <polygon
                      class="stV2"
                      points="158.16,103.39 156.71,103.39 157.43,103.81 			"
                    />
                    <polygon
                      class="stV2"
                      points="154.24,105.39 154.24,105.65 154.46,105.52 			"
                    />
                    <polygon
                      class="stV2"
                      points="160.76,105.72 160.76,105.38 160.46,105.55 			"
                    />
                  </g>
                  <g>
                    <path
                      class="stV2"
                      d="M153.32,108.03L153.32,108.03c-0.13-0.23-0.05-0.53,0.18-0.67l7.48-4.3c0.23-0.13,0.53-0.05,0.67,0.18l0,0
				c0.13,0.23,0.05,0.53-0.18,0.67l-7.48,4.3C153.75,108.34,153.45,108.26,153.32,108.03z"
                    />
                    <path
                      class="stV2"
                      d="M161.68,108.03L161.68,108.03c0.13-0.23,0.05-0.53-0.18-0.67l-7.48-4.3c-0.23-0.13-0.53-0.05-0.67,0.18l0,0
				c-0.13,0.23-0.05,0.53,0.18,0.67l7.48,4.3C161.25,108.34,161.55,108.26,161.68,108.03z"
                    />
                  </g>
                  <g>
                    <path
                      class="stV2"
                      d="M152.79,112.03c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h0.38v-0.97H152.79z"
                    />
                    <path
                      class="stV2"
                      d="M162.21,112.03h-0.38V113h0.38c0.27,0,0.49-0.22,0.49-0.49C162.7,112.24,162.48,112.03,162.21,112.03z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      class="stV2"
                      d="M19.81,96h-4.63c-1.6,0-2.9,1.46-2.9,3.25h10.43C22.72,97.46,21.41,96,19.81,96z"
                    />
                  </g>
                  <path
                    class="stV2"
                    d="M10.49,108.36L10.49,108.36c-0.27,0-0.49-0.22-0.49-0.49v-4.66c0-0.27,0.22-0.49,0.49-0.49h0
			c0.27,0,0.49,0.22,0.49,0.49v4.66C10.98,108.15,10.76,108.36,10.49,108.36z"
                  />
                  <path
                    class="stV2"
                    d="M24.51,108.37L24.51,108.37c-0.27,0-0.49-0.22-0.49-0.49v-4.66c0-0.27,0.22-0.49,0.49-0.49h0
			c0.27,0,0.49,0.22,0.49,0.49v4.66C25,108.16,24.78,108.37,24.51,108.37z"
                  />
                  <g>
                    <path
                      class="stV2"
                      d="M18.29,107.72h-1.61l-2.2,1.27c-0.08,0.04-0.16,0.08-0.24,0.11v3.8h6.52v-3.77
				c-0.07-0.03-0.13-0.06-0.2-0.09L18.29,107.72z"
                    />
                    <path
                      class="stV2"
                      d="M16.71,103.39h1.44l2.26-1.3c0.11-0.06,0.23-0.11,0.34-0.14v-1.62h-6.52v1.66c0.07,0.03,0.13,0.06,0.2,0.09
				L16.71,103.39z"
                    />
                    <path
                      class="stV2"
                      d="M24.02,103.39h-1.34c0,0.52-0.27,1.03-0.75,1.31l-1.17,0.67v0.35l1.29,0.74c0.47,0.27,0.73,0.76,0.74,1.26
				h1.23V103.39z"
                    />
                    <path
                      class="stV2"
                      d="M12.96,106.38l1.28-0.74v-0.25l-1.29-0.74c-0.47-0.27-0.73-0.76-0.74-1.26h-1.23v4.33h1.23
				C12.19,107.19,12.47,106.66,12.96,106.38z"
                    />
                    <polygon
                      class="stV2"
                      points="16.68,107.72 18.29,107.72 17.48,107.26 			"
                    />
                    <polygon
                      class="stV2"
                      points="18.16,103.39 16.71,103.39 17.43,103.81 			"
                    />
                    <polygon
                      class="stV2"
                      points="14.24,105.39 14.24,105.65 14.46,105.52 			"
                    />
                    <polygon
                      class="stV2"
                      points="20.76,105.72 20.76,105.38 20.46,105.55 			"
                    />
                  </g>
                  <g>
                    <path
                      class="stV2"
                      d="M13.32,108.03L13.32,108.03c-0.13-0.23-0.05-0.53,0.18-0.67l7.48-4.3c0.23-0.13,0.53-0.05,0.67,0.18l0,0
				c0.13,0.23,0.05,0.53-0.18,0.67l-7.48,4.3C13.75,108.34,13.45,108.26,13.32,108.03z"
                    />
                    <path
                      class="stV2"
                      d="M21.68,108.03L21.68,108.03c0.13-0.23,0.05-0.53-0.18-0.67l-7.48-4.3c-0.23-0.13-0.53-0.05-0.67,0.18l0,0
				c-0.13,0.23-0.05,0.53,0.18,0.67l7.48,4.3C21.25,108.34,21.55,108.26,21.68,108.03z"
                    />
                  </g>
                  <g>
                    <path
                      class="stV2"
                      d="M12.79,112.03c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h0.38v-0.97H12.79z"
                    />
                    <path
                      class="stV2"
                      d="M22.21,112.03h-0.38V113h0.38c0.27,0,0.49-0.22,0.49-0.49C22.7,112.24,22.48,112.03,22.21,112.03z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      class="stV2"
                      d="M568.81,96h-4.63c-1.6,0-2.9,1.46-2.9,3.25h10.43C571.72,97.46,570.41,96,568.81,96z"
                    />
                  </g>
                  <path
                    class="stV2"
                    d="M559.65,108.36h-0.33c-0.18,0-0.33-0.15-0.33-0.33v-4.98c0-0.18,0.15-0.33,0.33-0.33h0.33
			c0.18,0,0.33,0.15,0.33,0.33v4.98C559.98,108.22,559.83,108.36,559.65,108.36z"
                  />
                  <path
                    class="stV2"
                    d="M573.67,108.37h-0.33c-0.18,0-0.33-0.15-0.33-0.33v-4.98c0-0.18,0.15-0.33,0.33-0.33h0.33
			c0.18,0,0.33,0.15,0.33,0.33v4.98C574,108.23,573.85,108.37,573.67,108.37z"
                  />
                  <g>
                    <path
                      class="stV2"
                      d="M567.29,107.72h-1.61l-2.2,1.27c-0.08,0.04-0.16,0.08-0.24,0.11v3.8h6.52v-3.77
				c-0.07-0.03-0.13-0.06-0.2-0.09L567.29,107.72z"
                    />
                    <path
                      class="stV2"
                      d="M565.71,103.39h1.44l2.26-1.3c0.11-0.06,0.23-0.11,0.34-0.14v-1.62h-6.52v1.66c0.07,0.03,0.13,0.06,0.2,0.09
				L565.71,103.39z"
                    />
                    <path
                      class="stV2"
                      d="M573.02,103.39h-1.34c0,0.52-0.27,1.03-0.75,1.31l-1.17,0.67v0.35l1.29,0.74c0.47,0.27,0.73,0.76,0.74,1.26
				h1.23V103.39z"
                    />
                    <path
                      class="stV2"
                      d="M561.96,106.38l1.28-0.74v-0.25l-1.29-0.74c-0.47-0.27-0.73-0.76-0.74-1.26h-1.23v4.33h1.23
				C561.19,107.19,561.47,106.66,561.96,106.38z"
                    />
                    <polygon
                      class="stV2"
                      points="565.68,107.72 567.29,107.72 566.48,107.26 			"
                    />
                    <polygon
                      class="stV2"
                      points="567.16,103.39 565.71,103.39 566.43,103.81 			"
                    />
                    <polygon
                      class="stV2"
                      points="563.24,105.39 563.24,105.65 563.46,105.52 			"
                    />
                    <polygon
                      class="stV2"
                      points="569.76,105.72 569.76,105.38 569.46,105.55 			"
                    />
                  </g>
                  <g>
                    <path
                      class="stV2"
                      d="M562.4,108.17l-0.16-0.28c-0.09-0.15-0.04-0.35,0.12-0.44l7.76-4.47c0.16-0.09,0.36-0.04,0.45,0.12
				l0.16,0.28c0.09,0.15,0.04,0.35-0.12,0.44l-7.76,4.47C562.69,108.38,562.49,108.33,562.4,108.17z"
                    />
                    <path
                      class="stV2"
                      d="M570.6,108.17l0.16-0.28c0.09-0.15,0.04-0.35-0.12-0.44l-7.76-4.47c-0.16-0.09-0.36-0.04-0.45,0.12
				l-0.16,0.28c-0.09,0.15-0.04,0.35,0.12,0.44l7.76,4.47C570.31,108.38,570.51,108.33,570.6,108.17z"
                    />
                  </g>
                  <g>
                    <path
                      class="stV2"
                      d="M561.79,112.03c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h0.38v-0.97H561.79z"
                    />
                    <path
                      class="stV2"
                      d="M571.21,112.03h-0.38V113h0.38c0.27,0,0.49-0.22,0.49-0.49C571.7,112.24,571.48,112.03,571.21,112.03z"
                    />
                  </g>
                </g>
                <g>
                  <g>
                    <path
                      class="stV2"
                      d="M428.81,96h-4.63c-1.6,0-2.9,1.46-2.9,3.25h10.43C431.72,97.46,430.41,96,428.81,96z"
                    />
                  </g>
                  <path
                    class="stV2"
                    d="M419.49,108.36L419.49,108.36c-0.27,0-0.49-0.22-0.49-0.49v-4.65c0-0.27,0.22-0.49,0.49-0.49l0,0
			c0.27,0,0.49,0.22,0.49,0.49v4.65C419.98,108.14,419.76,108.36,419.49,108.36z"
                  />
                  <path
                    class="stV2"
                    d="M433.51,108.37L433.51,108.37c-0.27,0-0.49-0.22-0.49-0.49v-4.65c0-0.27,0.22-0.49,0.49-0.49l0,0
			c0.27,0,0.49,0.22,0.49,0.49v4.65C434,108.15,433.78,108.37,433.51,108.37z"
                  />
                  <g>
                    <path
                      class="stV2"
                      d="M427.29,107.72h-1.61l-2.2,1.27c-0.08,0.04-0.16,0.08-0.24,0.11v3.8h6.52v-3.77
				c-0.07-0.03-0.13-0.06-0.2-0.09L427.29,107.72z"
                    />
                    <path
                      class="stV2"
                      d="M425.71,103.39h1.44l2.26-1.3c0.11-0.06,0.23-0.11,0.34-0.14v-1.62h-6.52v1.66c0.07,0.03,0.13,0.06,0.2,0.09
				L425.71,103.39z"
                    />
                    <path
                      class="stV2"
                      d="M433.02,103.39h-1.34c0,0.52-0.27,1.03-0.75,1.31l-1.17,0.67v0.35l1.29,0.74c0.47,0.27,0.73,0.76,0.74,1.26
				h1.23V103.39z"
                    />
                    <path
                      class="stV2"
                      d="M421.96,106.38l1.28-0.74v-0.25l-1.29-0.74c-0.47-0.27-0.73-0.76-0.74-1.26h-1.23v4.33h1.23
				C421.19,107.19,421.47,106.66,421.96,106.38z"
                    />
                    <polygon
                      class="stV2"
                      points="425.68,107.72 427.29,107.72 426.48,107.26 			"
                    />
                    <polygon
                      class="stV2"
                      points="427.16,103.39 425.71,103.39 426.43,103.81 			"
                    />
                    <polygon
                      class="stV2"
                      points="423.24,105.39 423.24,105.65 423.46,105.52 			"
                    />
                    <polygon
                      class="stV2"
                      points="429.76,105.72 429.76,105.38 429.46,105.55 			"
                    />
                  </g>
                  <g>
                    <path
                      class="stV2"
                      d="M422.32,108.03L422.32,108.03c-0.13-0.23-0.05-0.53,0.18-0.67l7.48-4.3c0.23-0.13,0.53-0.05,0.67,0.18l0,0
				c0.13,0.23,0.05,0.53-0.18,0.67l-7.48,4.3C422.75,108.34,422.45,108.26,422.32,108.03z"
                    />
                    <path
                      class="stV2"
                      d="M430.68,108.03L430.68,108.03c0.13-0.23,0.05-0.53-0.18-0.67l-7.48-4.3c-0.23-0.13-0.53-0.05-0.67,0.18l0,0
				c-0.13,0.23-0.05,0.53,0.18,0.67l7.48,4.3C430.25,108.34,430.55,108.26,430.68,108.03z"
                    />
                  </g>
                  <g>
                    <path
                      class="stV2"
                      d="M421.79,112.03c-0.27,0-0.49,0.22-0.49,0.49c0,0.27,0.22,0.49,0.49,0.49h0.38v-0.97H421.79z"
                    />
                    <path
                      class="stV2"
                      d="M431.21,112.03h-0.38V113h0.38c0.27,0,0.49-0.22,0.49-0.49C431.7,112.24,431.48,112.03,431.21,112.03z"
                    />
                  </g>
                </g>
              </g>

              <foreignObject x="200" y="15" width="183" height="80">
                <div 
                  class="d-flex align-items-end999 flex-column"
                  style="height: 80px"
                >
                  <div class="mt-auto"><inline-svg :src="shipSideUrl" /></div>
                </div>
              </foreignObject>
              <!-- :transform="ShipChange_Transform" -->
              <!-- <g class="styleShipChange_Direction" @click="ReplaceSide">
                <path
                  id="ShipChange_Direction"
                :transform="ShipChange_Transform"
                  d="M285.41,76.56h13.18c0.5,0,0.91-0.4,0.91-0.91s-0.4-0.91-0.91-0.91H287.6l1.48-1.48
	c0.35-0.35,0.35-0.93,0-1.28c-0.35-0.35-0.93-0.35-1.28,0l-2.95,2.94c-0.22,0.17-0.36,0.43-0.36,0.72
	C284.5,76.15,284.9,76.56,285.41,76.56z M299.24,79.12c-0.21-0.21-0.51-0.3-0.79-0.25h-13.04c-0.5,0-0.91,0.4-0.91,0.91
	s0.4,0.91,0.91,0.91h10.99l-1.47,1.47c-0.35,0.35-0.35,0.93,0,1.28c0.18,0.18,0.41,0.26,0.64,0.26c0.23,0,0.46-0.09,0.64-0.26
	l3.03-3.03C299.59,80.05,299.59,79.48,299.24,79.12z"
                />
              </g> -->

              <text
                id="Ship_Name"
                :transform="VesselNameTransform"
                class="styleVesselName"
              >
                {{ mScheduleItem.vessel.name }}
              </text>
              <g id="Ship_Lenght">
                <g>
                  <g>
                    <line
                      class="stV38"
                      x1="310.5"
                      y1="102.11"
                      x2="311"
                      y2="102.11"
                    />
                    <line
                      class="stV39"
                      x1="312"
                      y1="102.11"
                      x2="385.15"
                      y2="102.11"
                    />
                    <line
                      class="stV38"
                      x1="385.65"
                      y1="102.11"
                      x2="386.15"
                      y2="102.11"
                    />
                    <g>
                      <path
                        class="stV5"
                        d="M392.18,102.11c-2.84,1.05-6.36,2.85-8.55,4.76l1.72-4.76l-1.72-4.75
					C385.82,99.26,389.34,101.06,392.18,102.11z"
                      />
                    </g>
                  </g>
                </g>
                <g>
                  <g>
                    <line
                      class="stV38"
                      x1="273.5"
                      y1="102.11"
                      x2="273"
                      y2="102.11"
                    />
                    <line
                      class="stV39"
                      x1="272"
                      y1="102.11"
                      x2="198.85"
                      y2="102.11"
                    />
                    <line
                      class="stV38"
                      x1="198.35"
                      y1="102.11"
                      x2="197.85"
                      y2="102.11"
                    />
                    <g>
                      <path
                        class="stV5"
                        d="M191.82,102.11c2.84-1.05,6.36-2.85,8.55-4.76l-1.72,4.76l1.72,4.75
					C198.18,104.96,194.66,103.16,191.82,102.11z"
                      />
                    </g>
                  </g>
                </g>
                <rect
                  x="276.16"
                  y="95"
                  class="stV35"
                  width="30.06"
                  height="10.48"
                />
                <text
                  transform="matrix(1 0 0 1 279.323 103.7905)"
                  class="styleLOA"
                >
                  {{ mScheduleItem.vessel.loa }} m
                </text>
              </g>
              <g id="Ship_Draft">
                <g>
                  <g>
                    <line
                      class="stV38"
                      x1="407.18"
                      y1="70.46"
                      x2="407.18"
                      y2="69.96"
                    />
                    <line
                      class="stV41"
                      x1="407.18"
                      y1="69.08"
                      x2="407.18"
                      y2="62.44"
                    />
                    <line
                      class="stV38"
                      x1="407.18"
                      y1="62"
                      x2="407.18"
                      y2="61.5"
                    />
                    <g>
                      <path
                        class="stV5"
                        d="M407.18,55.46c1.05,2.84,2.85,6.36,4.76,8.55l-4.76-1.72l-4.75,1.72C404.33,61.83,406.13,58.3,407.18,55.46
					z"
                      />
                    </g>
                  </g>
                </g>
                <g>
                  <g>
                    <line
                      class="stV38"
                      x1="407.18"
                      y1="85.46"
                      x2="407.18"
                      y2="85.96"
                    />
                    <line
                      class="stV41"
                      x1="407.18"
                      y1="86.85"
                      x2="407.18"
                      y2="93.49"
                    />
                    <line
                      class="stV38"
                      x1="407.18"
                      y1="93.93"
                      x2="407.18"
                      y2="94.43"
                    />
                    <g>
                      <path
                        class="stV5"
                        d="M407.18,100.46c-1.05-2.84-2.85-6.36-4.76-8.55l4.76,1.72l4.75-1.72
					C410.03,94.1,408.23,97.62,407.18,100.46z"
                      />
                    </g>
                  </g>
                </g>
                <rect
                  x="392.15"
                  y="72.32"
                  class="stV35"
                  width="30.06"
                  height="10.48"
                />
                <text
                  transform="matrix(1 0 0 1 397.8779 81.1105)"
                  class="styleDraft"
                >
                  {{ mScheduleItem.vessel.draft }} m
                </text>
              </g>
              <text
                id="Start_Bollard"
                transform="matrix(1 0 0 1 145 110.0443)"
                class="styleBollardName"
                text-anchor="end"
              >
                {{ mScheduleItem.StartBollardName }}
              </text>
              <text
                id="End_Bollard"
                transform="matrix(1 0 0 1 438 110.0437)"
                class="styleBollardName"
              >
                {{ mScheduleItem.endBollardName }}
              </text>

              <foreignObject x="0" y="0" width="160" height="100">
                <div class="styleVesselInfoLegend">
                  L<small class="pl-2 styleVesselInfo">{{
                    mScheduleItem.voyage.shippingLine
                  }}</small>
                </div>

                <div class="styleVesselInfoLegend">
                  A<small class="pl-2 styleVesselInfo">{{
                    mScheduleItem.voyage.agentName
                  }}</small>
                </div>
                <div
                  v-if="mScheduleItem.lineServiceName != ''"
                  class="styleVesselInfoLegend"
                >
                  S<small class="pl-2 styleVesselInfo">{{
                    mScheduleItem.lineServiceName
                  }}</small>
                </div>
              </foreignObject>
              <foreignObject x="390" y="0" width="200" height="30">
                <!-- <span class="svg-icon svg-icon-danger svg-icon-2x" style="cursor: pointer" @click="Delete_Plan()">
                  <i v-if="mScheduleItem.IsPlan" :title="deleteTitle" class="fas fa-trash-alt text-danger"></i> 

                </span> -->

                <div v-if="!isReadOnly" class="d-flex flex-row-reverse">
                  <div class="p-0 m-0">
                    <button
                      title="Change Berth Side"
                      @click="ReplaceSide"
                      class="btn btn-outline-primary font-weight-bold btn-sm mx-2 Mybtn1-primary Mybtn-size1 Mybtn-svg-BerthSide"
                    >
                      <i class="fas fa-exchange-alt"></i>
                    </button>
                  </div>
                  <div class="p-0 m-0">
                    <button
                      v-if="mScheduleItem.IsPlan"
                      :title="deleteTitle"
                      @click="Delete_Plan()"
                      class="btn btn-outline-danger font-weight-bold btn-sm mx-0 Mybtn1-danger Mybtn-size1 Mybtn-svg-Delete"
                      type="button"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </div>
              </foreignObject>
              <text
                transform="matrix(1 0 0 1 262.3423 138.522)"
                class="styleBerthName"
              >
                {{ mScheduleItem.berthName }}
              </text>
            </svg>
          </div>
        </div>

        <br />

        <div class="d-flex align-items-center p-0">
          <div class="d-flex flex-column flex-grow-1 mb-0">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 728 70"
              style="enable-background: new 0 0 728 70"
              xml:space="preserve"
            >
              <polygon
                class="stA0"
                points="149.1,18 147.1,18 152,35 147.1,52 149.1,52 154,35 "
              />
              <polygon
                class="stA0"
                points="293.1,18 291.1,18 296,35 291.1,52 293.1,52 298,35 "
              />
              <polygon
                class="stA0"
                points="365.1,18 363.1,18 368,35 363.1,52 365.1,52 370,35 "
              />
              <polygon
                class="stA0"
                points="221.1,18 219.1,18 224,35 219.1,52 221.1,52 226,35 "
              />
              <polygon
                class="stA0"
                points="437.1,18 435.1,18 440,35 435.1,52 437.1,52 442,35 "
              />
              <polygon
                class="stA0"
                points="509.1,18 507.1,18 512,35 507.1,52 509.1,52 514,35 "
              />
              <polygon
                class="stA0"
                points="77.1,18 75.1,18 80,35 75.1,52 77.1,52 82,35 "
              />

              <!-- Step1 -->
              <polygon
                id="Step1-Header"
                :class="
                  activeStep == 'ETA'
                    ? activeStepHeaderStyle
                    : 'styleDisableHeader'
                "
                points="70,0 0,0 0,18 75.1,18 "
              />
              <text
                id="Step1-ETA"
                transform="matrix(1 0 0 1 29.0724 12.1611)"
                class="styleStepFont10"
              >
                ETA
              </text>

              <g
                @mouseover="step_MouseOver(1)"
                @mouseleave="step_MouseLeave(1)"
              >
                <polygon
                  id="Step1-Body"
                  :class="styleStep1_Body"
                  points="75.1,18 0,18 0,52 75.1,52 80,35 "
                />

                <path
                  id="Step1-Icon"
                  v-if="stepETA_DateIcon"
                  class="styleDateIcon"
                  d="M35,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4H35c0.2,0,0.4,0.2,0.4,0.4
	v1.3C35.4,34.5,35.2,34.6,35,34.6z M38.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4
	h1.3C38.4,34.6,38.6,34.5,38.6,34.2z M41.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4H40c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4
	h1.3C41.6,34.6,41.8,34.5,41.8,34.2z M38.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4
	h1.3C38.4,37.9,38.6,37.7,38.6,37.5z M35.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4
	H35C35.2,37.9,35.4,37.7,35.4,37.5z M41.8,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4H40c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4
	h1.3C41.6,37.9,41.8,37.7,41.8,37.5z M45,28.8v11.8c0,0.9-0.7,1.6-1.6,1.6H31.6c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6
	h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4H35c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6
	C44.3,27.1,45,27.9,45,28.8z M43.4,40.3v-10H31.6v10c0,0.1,0.1,0.2,0.2,0.2h11.4C43.3,40.5,43.4,40.5,43.4,40.3z"
                />
                <g>
                  <rect
                    x="2"
                    y="21.5"
                    class="stA0"
                    width="70.2"
                    height="10.9"
                  />
                  <text
                    id="Step1-Date"
                    transform="translate(36, 30)  "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepETA_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="1.8"
                    y="37.3"
                    class="stA0"
                    width="70.2"
                    height="10.9"
                  />
                  <text
                    id="Step1-Time"
                    transform="translate(36, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepETA_Time }}
                  </text>
                </g>
              </g>

              <g
                @mouseover="step_Footer_MouseOver(1)"
                @mouseleave="step_Footer_MouseLeave(1)"
              >
                <polygon
                  id="Step1-Footer"
                  :class="
                    activeStep == 'ETA'
                      ? activeStepHeaderStyle
                      : styleStep1DisableFooter
                  "
                  points="0,70 70,70 75.1,52 0,52 "
                />

                <rect x="3.4" y="57.1" class="stA0" width="67.1" height="8.9" />
                <text
                  id="Step1-Properties"
                  transform="translate(35, 62)  "
                  class="styleStepFont8"
                  alignment-baseline="middle"
                  text-anchor="middle"
                  :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                >
                  {{ stepETA_EPT }}
                </text>
              </g>

              <!-- End Step1 -->

              <!-- Step2 -->

              <polygon
                id="Step2-Header"
                :class="
                  activeStep == 'anchorage'
                    ? activeStepHeaderStyle
                    : 'styleDisableHeader'
                "
                points="142,0 72,0 77.1,18 147.1,18 "
              />
              <text
                id="Step2-anchorage"
                transform="matrix(1 0 0 1 86.6309 12.1611)"
                class="styleStepFont10"
              >
                anchorage
              </text>
              <g
                @mouseover="step_MouseOver(2)"
                @mouseleave="step_MouseLeave(2)"
                @click="
                  step2ActiveApplyClick == true
                    ? showModalForm($event, 2)
                    : null
                "
              >
                <polygon
                  id="Step2-Body"
                  :class="styleStep2_Body"
                  points="147.1,18 77.1,18 82,35 77.1,52 147.1,52 152,35 "
                />

                <path
                  id="Step2-Icon"
                  v-if="stepAnchorage_DateIcon && step2ActiveApplyClick == true"
                  class="styleDateIcon"
                  d="M111,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4
	v1.3C111.4,34.5,111.2,34.6,111,34.6z M114.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3
	c0,0.2,0.2,0.4,0.4,0.4h1.3C114.4,34.6,114.6,34.5,114.6,34.2z M117.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4
	v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C117.6,34.6,117.8,34.5,117.8,34.2z M114.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3
	c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C114.4,37.9,114.6,37.7,114.6,37.5z M111.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4
	h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C111.2,37.9,111.4,37.7,111.4,37.5z M117.8,37.5v-1.3
	c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C117.6,37.9,117.8,37.7,117.8,37.5z M121,28.8
	v11.8c0,0.9-0.7,1.6-1.6,1.6h-11.8c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3
	c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6C120.3,27.1,121,27.9,121,28.8z
	 M119.4,40.3v-10h-11.8v10c0,0.1,0.1,0.2,0.2,0.2h11.4C119.3,40.5,119.4,40.5,119.4,40.3z"
                />
                <g>
                  <rect
                    x="80.5"
                    y="21.5"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step2-Date"
                    transform="translate(115, 30) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepAnchorage_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="80.3"
                    y="37.3"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step2-Time"
                    transform="translate(115, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepAnchorage_Time }}
                  </text>
                </g>
              </g>
              <g
                @mouseover="step_Footer_MouseOver(2)"
                @mouseleave="step_Footer_MouseLeave(2)"
              >
                <polygon
                  id="Step2-Footer"
                  :class="
                    activeStep == 'anchorage'
                      ? activeStepHeaderStyle
                      : styleStep2DisableFooter
                  "
                  points="72,70 142,70 147.1,52 77.1,52 "
                />
                <text
                  id="Step2-Properties"
                  class="styleStepFont8"
                  transform="translate(110, 62)  "
                  alignment-baseline="middle"
                  text-anchor="middle"
                >
                  {{ stepAnchorage_PortTime }}
                </text>
              </g>

              <!-- End Step2 -->

              <!-- Step3 -->
              <polygon
                id="Step3-Header"
                :class="
                  activeStep == 'Berth'
                    ? activeStepHeaderStyle
                    : 'styleDisableHeader'
                "
                points="214,0 144,0 149.1,18 219.1,18 "
              />
              <text
                id="Step3-Berth"
                transform="matrix(1 0 0 1 170.2616 12.1454)"
                class="styleStepFont10"
              >
                Berth
              </text>
              <g
                @mouseover="step_MouseOver(3)"
                @mouseleave="step_MouseLeave(3)"
                @click="
                  step3ActiveApplyClick == true
                    ? showModalForm($event, 3)
                    : null
                "
              >
                <polygon
                  id="Step3-Body"
                  :class="styleStep3_Body"
                  points="219.1,18 149.1,18 154,35 149.1,52 219.1,52 224,35 "
                />

                <path
                  id="Step3-Icon"
                  v-if="stepBerth_DateIcon && step3ActiveApplyClick == true"
                  class="styleDateIcon"
                  d="M184,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4
	v1.3C184.4,34.5,184.2,34.6,184,34.6z M187.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3
	c0,0.2,0.2,0.4,0.4,0.4h1.3C187.4,34.6,187.6,34.5,187.6,34.2z M190.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4
	v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C190.6,34.6,190.8,34.5,190.8,34.2z M187.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3
	c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C187.4,37.9,187.6,37.7,187.6,37.5z M184.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4
	h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C184.2,37.9,184.4,37.7,184.4,37.5z M190.8,37.5v-1.3
	c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C190.6,37.9,190.8,37.7,190.8,37.5z M194,28.8
	v11.8c0,0.9-0.7,1.6-1.6,1.6h-11.8c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3
	c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6C193.3,27.1,194,27.9,194,28.8z
	 M192.4,40.3v-10h-11.8v10c0,0.1,0.1,0.2,0.2,0.2h11.4C192.3,40.5,192.4,40.5,192.4,40.3z"
                />
                <g>
                  <rect
                    x="152.5"
                    y="21.5"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step3-Date"
                    transform="translate(185, 30) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepBerth_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="152.2"
                    y="37.2"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step3-Time"
                    transform="translate(185, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepBerth_Time }}
                  </text>
                </g>
              </g>

              <g
                @mouseover="step_Footer_MouseOver(3)"
                @mouseleave="step_Footer_MouseLeave(3)"
              >
                <polygon
                  id="Step3-Footer"
                  :class="
                    activeStep == 'Berth'
                      ? activeStepHeaderStyle
                      : styleStep3DisableFooter
                  "
                  points="144,70 214,70 219.1,52 149.1,52 "
                />
                <rect x="148" y="57.1" class="stA0" width="67.1" height="8.9" />
                <text
                  id="Step3-Properties"
                  class="styleStepFont8"
                  transform="translate(180, 62)  "
                  alignment-baseline="middle"
                  text-anchor="middle"
                >
                  {{ stepBerth_BerthTime }}
                </text>
              </g>

              <!-- End Step3 -->

              <!-- Step4 -->

              <polygon
                id="Step4-Header"
                :class="
                  activeStep == 'startLoadOperation'
                    ? activeStepHeaderStyle
                    : 'styleDisableHeader'
                "
                points="286,0 216,0 221.1,18 291.1,18 "
              />
              <text
                id="Step4-Start_Op."
                transform="matrix(1 0 0 1 235.3368 12.1454)"
                class="styleStepFont10"
              >
                Start LO.
              </text>
              <g
                @mouseover="step_MouseOver(4)"
                @mouseleave="step_MouseLeave(4)"
                @click="
                  step4ActiveApplyClick == true
                    ? showModalForm($event, 4)
                    : null
                "
              >
                <polygon
                  id="Step4-Body"
                  :class="styleStep4_Body"
                  points="291.1,18 221.1,18 226,35 221.1,52 291.1,52 296,35 "
                />

                <path
                  id="Step4-Icon"
                  v-if="
                    stepStartLoadOperation_DateIcon && step4ActiveApplyClick == true
                  "
                  class="styleDateIcon"
                  d="M257,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4
	v1.3C257.4,34.5,257.2,34.6,257,34.6z M260.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3
	c0,0.2,0.2,0.4,0.4,0.4h1.3C260.4,34.6,260.6,34.5,260.6,34.2z M263.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4
	v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C263.6,34.6,263.8,34.5,263.8,34.2z M260.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3
	c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C260.4,37.9,260.6,37.7,260.6,37.5z M257.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4
	h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C257.2,37.9,257.4,37.7,257.4,37.5z M263.8,37.5v-1.3
	c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C263.6,37.9,263.8,37.7,263.8,37.5z M267,28.8
	v11.8c0,0.9-0.7,1.6-1.6,1.6h-11.8c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3
	c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6C266.3,27.1,267,27.9,267,28.8z
	 M265.4,40.3v-10h-11.8v10c0,0.1,0.1,0.2,0.2,0.2h11.4C265.3,40.5,265.4,40.5,265.4,40.3z"
                />
                <g>
                  <rect
                    x="224.5"
                    y="21.5"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step4-Date"
                    transform="translate(260, 30) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepStartLoadOperation_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="224.2"
                    y="37.2"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step4-Time"
                    transform="translate(260, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepStartLoadOperation_Time }}
                  </text>
                </g>
              </g>
              <g
                @mouseover="step_Footer_MouseOver(4)"
                @mouseleave="step_Footer_MouseLeave(4)"
              >
                <polygon
                  id="Step4-Footer"
                  :class="
                    activeStep == 'startLoadOperation'
                      ? activeStepHeaderStyle
                      : styleStep4DisableFooter
                  "
                  points="216,70 286,70 291.1,52 221.1,52 "
                />

                <text
                  id="Step4-Properties"
                  class="styleStepFont8"
                  transform="translate(255, 62)  "
                  alignment-baseline="middle"
                  text-anchor="middle"
                >
                  {{ stepStartLoadOperation_OperationTime }}
                </text>
              </g>

              <!-- End Step4 -->

              <!-- Step5 -->
              <polygon
                id="Step5-Header"
                :class="
                  activeStep == 'endLoadOperation'
                    ? activeStepHeaderStyle
                    : 'styleDisableHeader'
                "
                points="502,0 432,0 437.1,18 507.1,18 "
              />

              <text
                id="Step5-End_Op."
                transform="matrix(1 0 0 1 453.0294 12.0666)"
                class="styleStepFont10"
              >
                End LO.
              </text>
              <g
                @mouseover="step_MouseOver(5)"
                @mouseleave="step_MouseLeave(5)"
                @click="
                  step5ActiveApplyClick == true
                    ? showModalForm($event, 5)
                    : null
                "
              >
              <polygon
  id="Step5-Body"
  :class="styleStep5_Body"
  points="507.1,18 437.1,18 442,35 437.1,52 507.1,52 512,35"
/>


<path
  id="Step5-Icon"
  v-if="
    stepEndLoadOperation_DateIcon && step5ActiveApplyClick == true
  "
  class="styleDateIcon"
  d="M461,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4
  v1.3C461.4,34.5,461.2,34.6,461,34.6z M464.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3
  c0,0.2,0.2,0.4,0.4,0.4h1.3C464.4,34.6,464.6,34.5,464.6,34.2z M467.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4
  v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C467.6,34.6,467.8,34.5,467.8,34.2z M464.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3
  c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C464.4,37.9,464.6,37.7,464.6,37.5z M461.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4
  h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C461.2,37.9,461.4,37.7,461.4,37.5z M467.8,37.5v-1.3
  c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C467.6,37.9,467.8,37.7,467.8,37.5z M471,28.8
  v11.8c0,0.9-0.7,1.6-1.6,1.6h-11.8c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3
  c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6C470.3,27.1,471,27.9,471,28.8z
   M469.4,40.3v-10h-11.8v10c0,0.1,0.1,0.2,0.2,0.2h11.4C469.3,40.5,469.4,40.5,469.4,40.3z"
/>

                <g>
                  <rect
                    x="440.5"
                    y="21.5"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step5-Date"
                    transform="translate(474, 30) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepEndLoadOperation_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="440.2"
                    y="37.2"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step5-Time"
                    transform="translate(474, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepEndLoadOperation_Time }}
                  </text>
                </g>
              </g>
              <polygon
  id="Step5-Footer"
  :class="
    activeStep == 'endLoadOperation'
      ? activeStepHeaderStyle
      : 'styleDisableFooter'
  "
  points="432,70 502,70 507.1,52 437.1,52"
/>

              <text
                id="Step5-Properties"
                transform="matrix(1 0 0 1 295.2785 65.0048)"
                class="styleStepFont10"
              ></text>

              <!-- End Step5 -->

              <!-- Step4000 -->

              <polygon
  id="Step4000-Header"
  :class="
    activeStep == 'startDischargeOperation'
      ? activeStepHeaderStyle
      : 'styleDisableHeader'
  "
  points="358,0 288,0 293.1,18 363.1,18"
/>

              <text
                id="Step4000-Start_Op."
                transform="matrix(1 0 0 1 305.3368 12.1454)"
                class="styleStepFont10"
              >
                Start Dis.
              </text>
              <g
                @mouseover="step_MouseOver(4000)"
                @mouseleave="step_MouseLeave(4000)"
                @click="
                  step4000ActiveApplyClick == true
                    ? showModalForm($event, 4000)
                    : null
                "
              >
              <polygon
  id="Step4000-Body"
  :class="styleStep4000_Body"
  points="363.1,18 293.1,18 298,35 293.1,52 363.1,52 368,35"
/>



<path
  id="Step4000-Icon"
  v-if="
    stepStartDischargeOperation_DateIcon && step4000ActiveApplyClick == true
  "
  class="styleDateIcon"
  d="M329,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4
  v1.3C329.4,34.5,329.2,34.6,329,34.6z M332.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3
  c0,0.2,0.2,0.4,0.4,0.4h1.3C332.4,34.6,332.6,34.5,332.6,34.2z M335.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4
  v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C335.6,34.6,335.8,34.5,335.8,34.2z M332.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3
  c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C332.4,37.9,332.6,37.7,332.6,37.5z M329.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4
  h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C329.2,37.9,329.4,37.7,329.4,37.5z M335.8,37.5v-1.3
  c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C335.6,37.9,335.8,37.7,335.8,37.5z M339,28.8
  v11.8c0,0.9-0.7,1.6-1.6,1.6h-11.8c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3
  c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6C338.3,27.1,339,27.9,339,28.8z
   M337.4,40.3v-10h-11.8v10c0,0.1,0.1,0.2,0.2,0.2h11.4C337.3,40.5,337.4,40.5,337.4,40.3z"
/>

                <g>
                  <rect
                    x="296.5"
                    y="21.5"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step4000-Date"
                    transform="translate(332, 30) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepStartDischargeOperation_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="296.2"
                    y="37.2"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step4000-Time"
                    transform="translate(332, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepStartDischargeOperation_Time }}
                  </text>
                </g>
              </g>
              <g
                @mouseover="step_Footer_MouseOver(4000)"
                @mouseleave="step_Footer_MouseLeave(4000)"
              >
              <polygon
  id="Step4000-Footer"
  :class="
    activeStep == 'startDischargeOperation'
      ? activeStepHeaderStyle
      : styleStep4000DisableFooter
  "
  points="288,70 358,70 363.1,52 293.1,52"
/>



                <text
                  id="Step4-Properties"
                  class="styleStepFont8"
                  transform="translate(327, 62)  "
                  alignment-baseline="middle"
                  text-anchor="middle"
                >
                  {{ stepStartDischargeOperation_OperationTime }}
                </text>
              </g>

              <!-- End Step4000 -->

              <!-- Step5000 -->
              <polygon
  id="Step5000-Header"
  :class="
    activeStep == 'endDischargeOperation'
      ? activeStepHeaderStyle
      : 'styleDisableHeader'
  "
  points="430,0 360,0 365.1,18 435.1,18"
/>


              <text
                id="Step5000-End_Op."
                transform="matrix(1 0 0 1 381.0294 12.0666)"
                class="styleStepFont10"
              >
                End Dis.
              </text>
              <g
                @mouseover="step_MouseOver(5000)"
                @mouseleave="step_MouseLeave(5000)"
                @click="
                  step5000ActiveApplyClick == true
                    ? showModalForm($event, 5000)
                    : null
                "
              >
              <polygon
  id="Step5000-Body"
  :class="styleStep5000_Body"
  points="435.1,18 365.1,18 370,35 365.1,52 435.1,52 440,35"
/>



<path
  id="Step5000-Icon"
  v-if="
    stepEndDischargeOperation_DateIcon && step5000ActiveApplyClick == true
  "
  class="styleDateIcon"
  d="M400,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4
  v1.3C400.4,34.5,400.2,34.6,400,34.6z M403.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3
  c0,0.2,0.2,0.4,0.4,0.4h1.3C403.4,34.6,403.6,34.5,403.6,34.2z M406.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4
  v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C406.6,34.6,406.8,34.5,406.8,34.2z M403.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3
  c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C403.4,37.9,403.6,37.7,403.6,37.5z M400.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4
  h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C400.2,37.9,400.4,37.7,400.4,37.5z M406.8,37.5v-1.3
  c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C406.6,37.9,406.8,37.7,406.8,37.5z M410,28.8
  v11.8c0,0.9-0.7,1.6-1.6,1.6h-11.8c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3
  c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6C409.3,27.1,410,27.9,410,28.8z
   M408.4,40.3v-10h-11.8v10c0,0.1,0.1,0.2,0.2,0.2h11.4C408.3,40.5,408.4,40.5,408.4,40.3z"
/>


                <g>
                  <rect
                    x="368.5"
                    y="21.5"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step5000-Date"
                    transform="translate(402, 30) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepEndDischargeOperation_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="368.2"
                    y="37.2"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step5000-Time"
                    transform="translate(402, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepEndDischargeOperation_Time }}
                  </text>
                </g>
              </g>
              <polygon
  id="Step5000-Footer"
  :class="
    activeStep == 'endDischargeOperation'
      ? activeStepHeaderStyle
      : 'styleDisableFooter'
  "
  points="360,70 430,70 435.1,52 365.1,52"
/>


              <text
                id="Step5000-Properties"
                transform="matrix(1 0 0 1 367.2785 65.0048)"
                class="styleStepFont10"
              ></text>
              

              <!-- End Step5000 -->

              <!-- Step6 -->
              <polygon
                id="Step6-Header"
                :class="
                  activeStep == 'Unberth'
                    ? activeStepHeaderStyle
                    : 'styleDisableHeader'
                "
                points="574,0 504,0 509.1,18 579.1,18 "
              />
              <text
                id="Step6-Unberth"
                transform="matrix(1 0 0 1 525.379 12.0666)"
                class="styleStepFont10"
              >
                Unberth
              </text>

              <g
                @mouseover="step_MouseOver(6)"
                @mouseleave="step_MouseLeave(6)"
                @click="
                  step6ActiveApplyClick == true
                    ? showModalForm($event, 6)
                    : null
                "
              >
                <polygon
                  id="Step6-Body"
                  :class="styleStep6_Body"
                  points="579.1,18 509.1,18 514,35 509.1,52 579.1,52 584,35 "
                />
                              <path
                id="Step6-Icon"
                v-if="stepUnberth_DateIcon && step6ActiveApplyClick == true"
                class="styleDateIcon"
                d="M544,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.3C544.4,34.5,544.2,34.6,544,34.6z M547.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C547.4,34.6,547.6,34.5,547.6,34.2z M550.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C550.6,34.6,550.8,34.5,550.8,34.2z M547.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C547.4,37.9,547.6,37.7,547.6,37.5z M544.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C544.2,37.9,544.4,37.7,544.4,37.5z M550.8,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C550.6,37.9,550.8,37.7,550.8,37.5z M554,28.8v11.8c0,0.9-0.7,1.6-1.6,1.6h-11.8c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6C553.3,27.1,554,27.9,554,28.8z M552.4,40.3v-10h-11.8v10c0,0.1,0.1,0.2,0.2,0.2h11.4C552.3,40.5,552.4,40.5,552.4,40.3z"
              />

                <g>
                  <rect
                    x="512.5"
                    y="21.5"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step6-Date"
                    transform="translate(544, 30) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepUnberth_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="512.2"
                    y="37.2"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step6-Time"
                    transform="translate(544, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepUnberth_Time }}
                  </text>
                </g>
              </g>

              <polygon
                id="Step6-Footer"
                :class="
                  activeStep == 'Unberth'
                    ? activeStepHeaderStyle
                    : 'styleDisableFooter'
                "
                points="504,70 574,70 579.1,52 509.1,52 "
              />
              <text
                id="Step6-Properties"
                transform="matrix(1 0 0 1 511.2785 65.0048)"
                class="styleStepFont10"
              ></text>

              <!-- End Step6 -->

              <!-- Step7 -->
              <polygon
                id="Step7-Header"
                :class="
                  activeStep == 'fullaway'
                    ? activeStepHeaderStyle
                    : 'styleDisableHeader'
                "
                points="646,0 576,0 581.1,18 651.1,18 "
              />
              <text
                id="Step7-Full_Away"
                transform="matrix(1 0 0 1 593.3541 12.0666)"
                class="styleStepFont10"
              >
                Full Away
              </text>

              <g
                @mouseover="step_MouseOver(7)"
                @mouseleave="step_MouseLeave(7)"
                @click="
                  step7ActiveApplyClick == true
                    ? showModalForm($event, 7)
                    : null
                "
              >
                <polygon
                  id="Step7-Body"
                  :class="styleStep7_Body"
                  points="651.1,18 581.1,18 586,35 581.1,52 651.1,52 656,35 "
                />

                <path
  id="Step7-Icon"
  v-if="stepFullaway_DateIcon && step7ActiveApplyClick == true"
  class="styleDateIcon"
  d="M617,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.3C617.4,34.5,617.2,34.6,617,34.6z M620.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C620.4,34.6,620.6,34.5,620.6,34.2z M623.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C623.6,34.6,623.8,34.5,623.8,34.2z M620.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C620.4,37.9,620.6,37.7,620.6,37.5z M617.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C617.2,37.9,617.4,37.7,617.4,37.5z M623.8,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C623.6,37.9,623.8,37.7,623.8,37.5z M627,28.8v11.8c0,0.9-0.7,1.6-1.6,1.6h-11.8c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6C626.3,27.1,627,27.9,627,28.8z M625.4,40.3v-10h-11.8v10c0,0.1,0.1,0.2,0.2,0.2h11.4C625.3,40.5,625.4,40.5,625.4,40.3z"
/>

                <g>
                  <rect
                    x="584.5"
                    y="21.5"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step7-Date"
                    transform="translate(619, 30) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepFullaway_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="584.2"
                    y="37.2"
                    class="stA0"
                    width="70.1"
                    height="10.9"
                  />
                  <text
                    id="Step7-Time"
                    transform="translate(619, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepFullaway_Time }}
                  </text>
                </g>
              </g>
              <polygon
                id="Step7-Footer"
                :class="
                  activeStep == 'fullaway'
                    ? activeStepHeaderStyle
                    : 'styleDisableFooter'
                "
                points="576,70 646,70 651.1,52 581.1,52 "
              />
              <text
                id="Step7-Properties"
                transform="matrix(1 0 0 1 583.2785 65.0048)"
                class="styleStepFont10"
              ></text>

              <!-- End Step7 -->

              <!-- Step8 -->
              <polygon
                id="Step8-Header"
                class="styleDisableHeader"
                points="728,0 648,0 653.1,18 728,18 "
              />
              <text
                id="Step8-ETD"
                transform="matrix(1 0 0 1 679.4157 12.1454)"
                class="styleStepFont10"
              >
                ETD
              </text>
              <g
                @mouseover="step_MouseOver(8)"
                @mouseleave="step_MouseLeave(8)"
              >
                <polygon
                  id="Step8-Body"
                  :class="styleStep8_Body"
                  points="653.1,18 658,35 653.1,52 728,52 728,18 "
                />
                <path
  id="Step8-Icon"
  v-if="stepETD_DateIcon"
  class="styleDateIcon"
  d="M689,34.6h-1.3c-0.2,0-0.4-0.2-0.4-0.4v-1.3c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.3C689.4,34.5,689.2,34.6,689,34.6z M692.6,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C692.4,34.6,692.6,34.5,692.6,34.2z M695.8,34.2v-1.3c0-0.2-0.2-0.4-0.4-0.4H694c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C695.6,34.6,695.8,34.5,695.8,34.2z M692.6,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C692.4,37.9,692.6,37.7,692.6,37.5z M689.4,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4h-1.3c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C689.2,37.9,689.4,37.7,689.4,37.5z M695.8,37.5v-1.3c0-0.2-0.2-0.4-0.4-0.4H694c-0.2,0-0.4,0.2-0.4,0.4v1.3c0,0.2,0.2,0.4,0.4,0.4h1.3C695.6,37.9,695.8,37.7,695.8,37.5z M699,28.8v11.8c0,0.9-0.7,1.6-1.6,1.6h-11.8c-0.9,0-1.6-0.7-1.6-1.6V28.8c0-0.9,0.7-1.6,1.6-1.6h1.6v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h4.3v-1.7c0-0.2,0.2-0.4,0.4-0.4h1.3c0.2,0,0.4,0.2,0.4,0.4v1.7h1.6C698.3,27.1,699,27.9,699,28.8z M697.4,40.3v-10h-11.8v10c0,0.1,0.1,0.2,0.2,0.2h11.4C697.3,40.5,697.4,40.5,697.4,40.3z"
/>

                <g>
                  <rect
                    x="657"
                    y="21.5"
                    class="stA0"
                    width="70.2"
                    height="10.9"
                  />
                  <text
                    id="Step8-Date"
                    transform="translate(694, 30) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                    :style="{ direction: getCurrentLocale === 'fa' ? 'rtl' : 'ltr' }"
                  >
                    {{ stepETD_Date }}
                  </text>
                </g>
                <g>
                  <rect
                    x="656.8"
                    y="37.2"
                    class="stA0"
                    width="70.2"
                    height="10.9"
                  />
                  <text
                    id="Step8-Time"
                    transform="translate(694, 45) "
                    alignment-baseline="middle"
                    text-anchor="middle"
                    class="styleStepFont10"
                  >
                    {{ stepETD_Time }}
                  </text>
                </g>
              </g>
              <polygon
                id="Step8-Footer"
                class="styleDisableFooter"
                points="648,70 728,70 728,52 653.1,52 "
              />
              <text
                id="Step8-Properties"
                transform="matrix(1 0 0 1 561.7764 65.0828)"
                class="styleStepFont10"
              ></text>

              <!-- End Step8 -->
            </svg>
          </div>
        </div>

        <div class="d-flex align-items-center p-0">
          <div class="d-flex flex-column flex-grow-1 mb-2 pl-15 pr-15">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 507.89 25.69"
              style="enable-background: new 0 0 507.89 25.69"
              xml:space="preserve"
            >
              <polygon
                v-if="activeBoxGuidLine"
                id="EPT-Box"
                class="st0A"
                points="211.68,25.69 281.68,25.69 286.82,7.69 216.82,7.69 "
              />
              <polyline
                v-if="activeEPTGuidLine"
                id="L1-Line"
                class="st1A"
                points="5.68,17.55 0,0 5.51,17.02 214.02,17.02 "
              />
              <polyline
                v-if="activeEPTGuidLine"
                id="R1-Line"
                class="st1A"
                points="501.94,17.41 507.89,0.02 502.12,16.89 283.89,16.89 "
              />
              <polyline
                v-if="activePortTimeGuidLine"
                id="L2-Line"
                class="st1A"
                points="74.07,17.46 70.24,-0.09 73.96,16.93 214.45,16.93 "
              />
              <polyline
                v-if="activePortTimeGuidLine"
                id="R2-Line"
                class="st1A"
                points="428.2,17.46 432.16,-0.09 428.32,16.94 283.14,16.94 "
              />
              <polyline
                v-if="activeBerthTimeGuidLine"
                id="L3-Line"
                class="st1A"
                points="97.08,17.35 95.25,-0.2 97.03,16.82 214.43,16.82 "
              />
              <polyline
                v-if="activeBerthTimeGuidLine"
                id="R3-Line"
                class="st1A"
                points="408.5,17.36 410.55,-0.19 408.57,16.83 283.58,16.83 "
              />
              <polyline
                v-if="activeLoadOperationGuidLine"
                id="L4-Line"
                class="st1A"
                points="156,17.26 155.75,-0.29 155.99,16.73 219.22,16.73 "
              />
              <polyline
                v-if="activeLoadOperationGuidLine"
                id="R4-Line"
                class="st1A"
                points="343.02,17.26 343.27,-0.29 343.03,16.73 283.8,16.73 "
              />
              <polyline
                v-if="activeDischargeOperationGuidLine"
                id="L4-Line"
                class="st1A"
                points="206,17.26 205.75,-0.29 205.99,16.73 219.22,16.73 "
              />
              <polyline
                v-if="activeDischargeOperationGuidLine"
                id="R4-Line"
                class="st1A"
                points="293.02,17.26 293.27,-0.29 293.03,16.73 283.8,16.73 "
              />
              <rect
                x="219.36"
                y="10"
                class="st2A"
                width="60.61"
                height="12.3"
              />

              <!-- transform="matrix(1 0 0 1 242.058 19.6988)" -->
              <text
                v-if="activeBoxTextGuidLine"
                id="EPT-Text"
                transform="translate(250, 17) "
                alignment-baseline="middle"
                text-anchor="middle"
                class="styleStepFont9"
              >
                {{ GuidLineTextBox }}
              </text>
            </svg>
          </div>
        </div>

        <div
          v-if="EnableContainerShipChart"
          class="d-flex align-items-center border border-secondary rounded p-2"
        >
          <div
            class="d-flex flex-column flex-grow-1 mb-2 test"
            style="min-height: 200px"
          >
            <apexchart
              type="bar"
              height="200"
              :options="chartOptions"
              :series="ChartSeries"
            ></apexchart>
          </div>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon
            class="text-danger"
            icon="stopwatch"
            font-scale="3"
            animation="cylon"
          ></b-icon>
          <p class="text-danger font-weight-bolder">Please wait...</p>
        </div>
      </template>
    </b-overlay>

    <b-modal
      id="modalSOFSubmitDate"
      title=""
      v-model="modalShowSOFSubmitDate"
      size="sm"
      centered
      content-class="shadow"
      header-class="pt-2 pb-2"
      footer-class="pt-2 pb-2"
    >
      <template #modal-title>
        <span class="font-weight-bolder font-size-sm"> {{ SubmitTitle }}</span>
      </template>

      <template #modal-footer>
        <b-overlay
          :show="showOverlayApply"
          rounded="sm"
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <button
            @click="Apply_Click"
            class="btn btn-outline-primary font-weight-bold btn-sm mx-2 Mybtn1-primary Mybtn-size1"
          >
            <i class="fas fa-check"></i>
            APPLY
          </button>
        </b-overlay>

        <b-overlay
          :show="showOverlayClear"
          rounded="sm"
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <button
            v-if="activeClearButton(menuId)"
            @click="Clear_Click"
            class="btn btn-outline-danger font-weight-bold btn-sm mx-2 Mybtn1-danger Mybtn-size1"
          >
            <i class="fas fa-eraser"></i>
            CLEAR
          </button>
        </b-overlay>
      </template>

      <b-form>
        <div :class="{ 'form-group--error': $v.currentDate.$error }">
          <b-row>
            <b-col>
              <date-picker
                v-model="currentDate"
                name="currentDate"
                type="datetime"
                placeholder="Choose Date"
                format="YYYY/MM/DD HH:mm"
                value-type="format"
                class="filterdate"
                position="left"
                :open.sync="openDialogDatePicker"
                @change="handleChangedatePicker"
              ></date-picker>
            </b-col>
          </b-row>
        </div>

        <b-row>
          <b-col>
            <b-form-invalid-feedback
              :state="$v.currentDate.$dirty ? !$v.currentDate.$anyError : null"
              v-if="!$v.currentDate.required"
            >
              Field is required
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { required } from "vuelidate/lib/validators";
import {
  Update_VoyageSOF_AnchorageIn,
  AddOrUpdate_VoyageSOF_Berth,
  Delete_VoyageSOF_Berth,
  Update_VoyageSOF_AnchorageOut,
  Update_BerthSideByVoyageId,
  Delete_VoyageSOF_Plan,
} from "@/core/services/store/voyagesof.module";

import {
  Delete_ConceptItem,
  Update_ConceptBerthSideByVoyageId,
} from "@/core/services/store/concept.module";

import { mapGetters } from "vuex";
import { EnumColors, ImageSRC } from "@/mixins.ts";
import moment from "jalali-moment";

export default {
  name: "VesselTimeLineSVG",
  components: {
    DatePicker,
  },

  inject: ["showErrors", "showSuccess"],
  mixins: [EnumColors, ImageSRC],

  data: () => {
    return {
      shipSideUrl: "",
      lines: [],
      textpoints: [],
      currentDate: null,
      currentOldDate: null,
      isCloseable: false,
      status: 0,
      menuId: 0,
      mVoyageId: 0,
      mConceptId: 0,
      mScheduleItem: null,
      startMonth: "",
      startWeek: "",
      endWeek: "",
      EPT: "",
      berthTime: null,
      PortTime: null,
      anchorage: "",
      Berth: null,
      unBerth: null,
      fullaway: null,
      ETD: null,
      eta: null,
      showOverlay: false,
      showOverlayApply: false,
      showOverlayClear: false,
      // isConcept: false,

      stepETA_Date: null,
      stepETA_Time: null,
      stepETA_DateIcon: false,
      stepETA_EPT: null,

      stepAnchorage_Date: null,
      stepAnchorage_Time: null,
      stepAnchorage_DateIcon: false,
      stepAnchorage_PortTime: null,

      stepBerth_Date: null,
      stepBerth_Time: null,
      stepBerth_DateIcon: false,
      stepBerth_BerthTime: null,

      stepStartLoadOperation_Date: null,
      stepStartLoadOperation_Time: null,
      stepStartLoadOperation_DateIcon: false,
      stepStartLoadOperation_OperationTime: null,

      stepEndLoadOperation_Date: null,
      stepEndLoadOperation_Time: null,
      stepEndLoadOperation_DateIcon: false,

      stepStartDischargeOperation_Date: null,
      stepStartDischargeOperation_Time: null,
      stepStartDischargeOperation_DateIcon: false,
      stepStartDischargeOperation_OperationTime: null,
      
      stepEndDischargeOperation_Date: null,
      stepEndDischargeOperation_Time: null,
      stepEndDischargeOperation_DateIcon: false,

      stepUnberth_Date: null,
      stepUnberth_Time: null,
      stepUnberth_DateIcon: false,

      stepFullaway_Date: null,
      stepFullaway_Time: null,
      stepFullaway_DateIcon: false,

      stepETD_Date: null,
      stepETD_Time: null,
      stepETD_DateIcon: false,

      Step1Disable: false,
      Step2Disable: false,
      Step3Disable: false,
      Step4Disable: false,
      Step5Disable: false,
      Step6Disable: false,
      Step7Disable: false,
      Step8Disable: false,
      styleStep1_Body: "",
      styleStep2_Body: "",
      styleStep3_Body: "",
      styleStep4_Body: "",
      styleStep4000_Body: "",
      styleStep5_Body: "",
      styleStep5000_Body: "",
      styleStep6_Body: "",
      styleStep7_Body: "",
      styleStep8_Body: "",

      activeStep: "ETA",
      activeStepHeaderStyle: "styleStep1_Header",

      modalShowSOFSubmitDate: false,
      SubmitTitle: "",

      step2ActiveApplyClick: false,
      step3ActiveApplyClick: false,
      step4ActiveApplyClick: false,
      step4000ActiveApplyClick: false,
      step5ActiveApplyClick: false,
      step5000ActiveApplyClick: false,
      step6ActiveApplyClick: false,
      step7ActiveApplyClick: false,

      step2ActiveClearClick: false,
      step3ActiveClearClick: false,
      step4ActiveClearClick: false,
      step4000ActiveClearClick: false,
      step5ActiveClearClick: false,
      step5000ActiveClearClick: false,
      step6ActiveClearClick: false,
      step7ActiveClearClick: false,

      styleStep1DisableFooter: "styleDisableFooter",
      styleStep2DisableFooter: "styleDisableFooter",
      styleStep3DisableFooter: "styleDisableFooter",
      styleStep4DisableFooter: "styleDisableFooter",
      styleStep4000DisableFooter: "styleDisableFooter",

      activeBoxGuidLine: false,
      activeBoxTextGuidLine: false,
      activeEPTGuidLine: false,
      activePortTimeGuidLine: false,
      activeBerthTimeGuidLine: false,
      activeLoadOperationGuidLine: false,
      activeDischargeOperationGuidLine: false,
      GuidLineTextBox: "",
      VesselNameTransform: "",
      ShipChange_Transform: "",

      ChartSeries: null,
      chartOptions: {
        chart: {
          type: "bar",
          height: 150,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "",
        },
        xaxis: {
          categories: ["Discharge", "Load", 'Restow"'],
          labels: {
            formatter: function(val) {
              return val; // + "K";
            },
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val; // + "K";
            },
          },
        },
        fill: {
          opacity: 1,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
      },
      EnableContainerShipChart: false,
      openDialogDatePicker : false
    };
  },
  mounted() {
    //this.refreshData(this.ScheduleItem);
    this.GetScheduleDatabyVoyageId(this.VoyageId, this.ConceptId);
  },
  computed: {
    ...mapGetters([
      "getVoyageSOFErrors",
      "getVoyageSOFMessages",
      "getConceptChartErrors",
      "getCurrentLocale"
    ]),
  },
  watch: {
    // ScheduleItem: (val) => {
    //   alert("ScheduleItem");
    //   this.refreshData(val);
    // },

    // VoyageId: (val) => {
    //   alert("VoyageId");
    //   this.GetScheduleDatabyVoyageId(val, this.ConceptId);
    // },
  },

  props: {
    ScheduleItem: Object,
    VoyageId: Number,
    ConceptId: Number,
    isReadOnly: Boolean,
    isConcept: Boolean,
    mUpdateScheduleByVoyageId: Function,
    mGetScheduleByVoyageId: Function,
    mGetConceptItemByVoyageIdConceptId: Function,
    // mUpdateScheduleBerthSideByVoyageId: Function,
    mDeleteScheduleByVoyageId: Function,
  },

  methods: {
    handleChangedatePicker(value, type){
      if (type === 'minute') {
        this.openDialogDatePicker = false;
      }
    },
    step_MouseOver(stepId) {
      switch (stepId) {
        case 1: {
          this.styleStep1_Body =
            this.Step1Disable == true
              ? "styleDisableBody"
              : "styleStep1_Body styleStep_Body_hover";
          break;
        }
        case 2: {
          this.styleStep2_Body =
            this.Step2Disable == true
              ? "styleDisableBody"
              : "styleStep2_Body styleStep_Body_hover";
          break;
        }
        case 3: {
          this.styleStep3_Body =
            this.Step3Disable == true
              ? "styleDisableBody"
              : "styleStep3_Body styleStep_Body_hover";
          break;
        }
        case 4: {
          this.styleStep4_Body =
            this.Step4Disable == true
              ? "styleDisableBody"
              : "styleStep4_Body styleStep_Body_hover";
          break;
        }
        case 4000: {
          this.styleStep4000_Body =
            this.Step4000Disable == true
              ? "styleDisableBody"
              : "styleStep4000_Body styleStep_Body_hover";
          break;
        }
        case 5: {
          this.styleStep5_Body =
            this.Step5Disable == true
              ? "styleDisableBody"
              : "styleStep5_Body styleStep_Body_hover";
          break;
        }
        case 5000: {
          this.styleStep5000_Body =
            this.Step5000Disable == true
              ? "styleDisableBody"
              : "styleStep5000_Body styleStep_Body_hover";
          break;
        }
        case 6: {
          this.styleStep6_Body =
            this.Step6Disable == true
              ? "styleDisableBody"
              : "styleStep6_Body styleStep_Body_hover";
          break;
        }
        case 7: {
          this.styleStep7_Body =
            this.Step7Disable == true
              ? "styleDisableBody"
              : "styleStep7_Body styleStep_Body_hover";
          break;
        }
        case 8: {
          this.styleStep8_Body =
            this.Step8Disable == true
              ? "styleDisableBody"
              : "styleStep8_Body styleStep_Body_hover";
          break;
        }
      }
    },
    step_MouseLeave(stepId) {
      switch (stepId) {
        case 1: {
          this.styleStep1_Body =
            this.Step1Disable == true ? "styleDisableBody" : "styleStep1_Body";
          break;
        }
        case 2: {
          this.styleStep2_Body =
            this.Step2Disable == true ? "styleDisableBody" : "styleStep2_Body";
          break;
        }
        case 3: {
          this.styleStep3_Body =
            this.Step3Disable == true ? "styleDisableBody" : "styleStep3_Body";
          break;
        }
        case 4: {
          this.styleStep4_Body =
            this.Step4Disable == true ? "styleDisableBody" : "styleStep4_Body";
          break;
        }
        case 4000: {
          this.styleStep4000_Body =
            this.Step4000Disable == true ? "styleDisableBody" : "styleStep4000_Body";
          break;
        }
        case 5: {
          this.styleStep5_Body =
            this.Step5Disable == true ? "styleDisableBody" : "styleStep5_Body";
          break;
        }
        case 5000: {
          this.styleStep5000_Body =
            this.Step5000Disable == true ? "styleDisableBody" : "styleStep5000_Body";
          break;
        }
        case 6: {
          this.styleStep6_Body =
            this.Step6Disable == true ? "styleDisableBody" : "styleStep6_Body";
          break;
        }
        case 7: {
          this.styleStep7_Body =
            this.Step7Disable == true ? "styleDisableBody" : "styleStep7_Body";
          break;
        }
        case 8: {
          this.styleStep8_Body =
            this.Step8Disable == true ? "styleDisableBody" : "styleStep8_Body";
          break;
        }
      }
    },

    step_Footer_MouseOver(stepId) {
      this.activeBoxGuidLine = false;
      this.activeBoxTextGuidLine = false;
      this.activeEPTGuidLine = false;
      this.activePortTimeGuidLine = false;
      this.activeBerthTimeGuidLine = false;
      this.activeLoadOperationGuidLine = false;
      this.activeDischargeOperationGuidLine = false;
      this.GuidLineTextBox = "";

      switch (stepId) {
        case 1: {
          if (this.stepETA_EPT != "") {
            if (this.activeStep != "ETA") {
              this.styleStep1DisableFooter =
                this.activeStep == "ETA"
                  ? this.activeStepHeaderStyle
                  : "styleDisableFooter styleStep1DisableFooter_hover";
            }
            this.GuidLineTextBox = "EPT";
            this.activeBoxGuidLine = true;
            this.activeBoxTextGuidLine = true;
            this.activeEPTGuidLine = true;
          }

          break;
        }
        case 2: {
          if (this.stepAnchorage_PortTime != "") {
            if (this.activeStep != "anchorage") {
              this.styleStep2DisableFooter =
                this.activeStep == "anchorage"
                  ? this.activeStepHeaderStyle
                  : "styleDisableFooter styleStep2DisableFooter_hover";
            }
            this.GuidLineTextBox = "Port Time";
            this.activeBoxGuidLine = true;
            this.activeBoxTextGuidLine = true;
            this.activePortTimeGuidLine = true;
          }

          break;
        }
        case 3: {
          if (this.stepBerth_BerthTime != "") {
            if (this.activeStep != "Berth") {
              this.styleStep3DisableFooter =
                this.activeStep == "Berth"
                  ? this.activeStepHeaderStyle
                  : "styleDisableFooter styleStep3DisableFooter_hover";
            }

            this.GuidLineTextBox = "Berth Time";
            this.activeBoxGuidLine = true;
            this.activeBoxTextGuidLine = true;
            this.activeBerthTimeGuidLine = true;
          }

          break;
        }
        case 4: {
          if (this.stepStartLoadOperation_OperationTime != "") {
            if (this.activeStep != "startLoadOperation") {
              this.styleStep4DisableFooter =
                this.activeStep == "startLoadOperation"
                  ? this.activeStepHeaderStyle
                  : "styleDisableFooter styleStep4DisableFooter_hover";
            }
            this.GuidLineTextBox = "Lo. Op. Time";
            this.activeBoxGuidLine = true;
            this.activeBoxTextGuidLine = true;
            this.activeLoadOperationGuidLine = true;
          }

          break;
        }
        case 4000: {
          if (this.stepStartDischargeOperation_OperationTime != "") {
            if (this.activeStep != "startDischargeOperation") {
              this.styleStep4000DisableFooter =
                this.activeStep == "startDischargeOperation"
                  ? this.activeStepHeaderStyle
                  : "styleDisableFooter styleStep4000DisableFooter_hover";
            }
            this.GuidLineTextBox = "Dis. Op. Time";
            this.activeBoxGuidLine = true;
            this.activeBoxTextGuidLine = true;
            this.activeDischargeOperationGuidLine = true;
          }

          break;
        }
      }
    },
    step_Footer_MouseLeave(stepId) {
      this.activeBoxGuidLine = false;
      this.activeBoxTextGuidLine = false;
      this.activeEPTGuidLine = false;
      this.activePortTimeGuidLine = false;
      this.activeBerthTimeGuidLine = false;
      this.activeLoadOperationGuidLine = false;
      this.activeDischargeOperationGuidLine = false;
      this.GuidLineTextBox = "";

      switch (stepId) {
        case 1: {
          if (this.stepETA_EPT != "" && this.activeStep != "ETA") {
            this.styleStep1DisableFooter =
              this.activeStep == "ETA"
                ? this.activeStepHeaderStyle
                : "styleDisableFooter ";
          }
          break;
        }
        case 2: {
          if (
            this.stepAnchorage_PortTime != "" &&
            this.activeStep != "anchorage"
          ) {
            this.styleStep2DisableFooter =
              this.activeStep == "anchorage"
                ? this.activeStepHeaderStyle
                : "styleDisableFooter ";
          }

          break;
        }
        case 3: {
          if (this.stepBerth_BerthTime != "" && this.activeStep != "Berth") {
            this.styleStep3DisableFooter =
              this.activeStep == "Berth"
                ? this.activeStepHeaderStyle
                : "styleDisableFooter ";
          }
          break;
        }
        case 4: {
          if (
            this.stepStartLoadOperation_OperationTime != "" &&
            this.activeStep != "startLoadOperation"
          ) {
            this.styleStep4DisableFooter =
              this.activeStep == "startLoadOperation"
                ? this.activeStepHeaderStyle
                : "styleDisableFooter ";
          }
          break;
        }
        case 4000: {
          if (
            this.stepStartDischargeOperation_OperationTime != "" &&
            this.activeStep != "startDischargeOperation"
          ) {
            this.styleStep4000DisableFooter =
              this.activeStep == "startDischargeOperation"
                ? this.activeStepHeaderStyle
                : "styleDisableFooter ";
          }
          break;
        }
      }
    },

    GetScheduleDatabyVoyageId(voyageId, conceptId) {
      const me = this;
      me.showOverlay = true;
      const callback2 = (data) => {
        if (data != null) {
          me.refreshData(data);
        }
        me.showOverlay = false;
      };
      if (me.isConcept == false) {
        me.mGetScheduleByVoyageId(voyageId, callback2);
      } else {
        me.mGetConceptItemByVoyageIdConceptId(voyageId, conceptId, callback2);
      }
    },

    Delete_Plan() {
      if (this.isConcept == false) {
        this.Delete_Planfn((res) => {
          if (res.isSuccess)
          {
            this.mDeleteScheduleByVoyageId(this.mVoyageId);
          }
        });
      } else {
        this.Delete_Conceptfn((res) => {     
           if (res.isSuccess)
          {
            this.mDeleteScheduleByVoyageId(this.mVoyageId);
          }
        });
      }
    },
    appendValue(id, value) {
      switch (id) {
        // case 1:
        //   this.mScheduleItem.eta = value;
        //   break;
        case 2:
          this.mScheduleItem.voyage.anchorage = value;
          break;
        case 3:
          this.mScheduleItem.voyage.berthDate = value;
          break;
        case 4:
          this.mScheduleItem.voyage.startLoadOperation = value;
          break;
        case 4000:
          this.mScheduleItem.voyage.startDischargeOperation = value;
          break;
        case 5:
          this.mScheduleItem.voyage.endLoadOperation = value;
          break;
        case 6:
          this.mScheduleItem.voyage.unberthDate = value;
          break;
        case 7:
          this.mScheduleItem.voyage.fullaway = value;
          break;
      }
    },

    showModalForm(event, id) {
      //this.isReadOnly
      //this.isConcept

      if (this.isConcept == false) {
        this.modalShowSOFSubmitDate = true;
        this.$nextTick(() => {
          this.menuId = id;

          switch (id) {
            case 2:
              this.SubmitTitle = "anchorage";
              break;
            case 3:
              this.SubmitTitle = "Berth";
              break;
            case 4:
              this.SubmitTitle = "Start Load Operation";
              break;
            case 4000:
              this.SubmitTitle = "Start Discharge Operation";
              break;
            case 5:
              this.SubmitTitle = "End Load Operation";
              break;
            case 5000:
              this.SubmitTitle = "End Discharge Operation";
              break;
            case 6:
              this.SubmitTitle = "Unberth";
              break;
            case 7:
              this.SubmitTitle = "fullaway";
              break;
          }

          switch (id) {
            case 2:
              this.currentDate =
                this.mScheduleItem.voyage.anchorage == ""
                  ? null
                  : this.mScheduleItem.voyage.anchorage;
              break;
            case 3:
              this.currentDate =
                this.mScheduleItem.voyage.berthDate == ""
                  ? null
                  : this.mScheduleItem.voyage.berthDate;
              break;
            case 4:
              this.currentDate =
                this.mScheduleItem.voyage.startLoadOperation == ""
                  ? null
                  : this.mScheduleItem.voyage.startLoadOperation;
              break;
            case 4000:
              this.currentDate =
                this.mScheduleItem.voyage.startDischargeOperation == ""
                  ? null
                  : this.mScheduleItem.voyage.startDischargeOperation;
              break;
            case 5:
              this.currentDate =
                this.mScheduleItem.voyage.endLoadOperation == ""
                  ? null
                  : this.mScheduleItem.voyage.endLoadOperation;
              break;
            case 6:
              this.currentDate =
                this.mScheduleItem.voyage.unberthDate == ""
                  ? null
                  : this.mScheduleItem.voyage.unberthDate;
              break;
            case 7:
              this.currentDate =
                this.mScheduleItem.voyage.fullaway == ""
                  ? null
                  : this.mScheduleItem.voyage.fullaway;
              break;
          }

          this.currentOldDate = this.currentDate;
        });
      }
    },

    Apply_Click() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      const me = this;
      const callback = (res) => {
        if (res.isSuccess == true) {
          const callback2 = (data) => {
            if (data != null) {
              me.mScheduleItem = data;
              me.updateComponent(me.mScheduleItem);
            }
            me.showOverlay = false;
            me.showOverlayApply = false;
            me.modalShowSOFSubmitDate = false;
          };

          me.mUpdateScheduleByVoyageId(me.mVoyageId, res.setScroll, callback2);
        } else {
          me.showOverlay = false;
          me.showOverlayApply = false;
        }
      };

      this.showOverlay = true;
      this.showOverlayApply = true;
      switch (this.menuId) {
        case 2:
          this.Change_Anchorage("", callback);
          break;
        case 3:
          if (this.currentDate <= this.mScheduleItem.voyage.anchorage) {
            this.showErrors([
              { messageText: "Berth Date must be larger anchorage Date " },
            ]);
            callback("error");
          } else {
            this.Change_Berth(callback);
          }
          break;
        case 4:
          if (this.currentDate <= this.mScheduleItem.voyage.berthDate) {
            this.showErrors([
              {
                messageText: "Start Load Operation Date must be larger Berth Date ",
              },
            ]);
            callback("error");
          } else {
            this.Change_StartLoadOperation(callback);
          }
          break;

        case 4000:
          if (this.currentDate <= this.mScheduleItem.voyage.berthDate) {
            this.showErrors([
              {
                messageText: "Start Discharge Date must be larger Berth Date ",
              },
            ]);
            callback("error");
          } else {
            this.Change_StartDischargeOperation(callback);
          }
          break;

        case 5:
          if (this.currentDate <= this.mScheduleItem.voyage.startLoadOperation) {
            this.showErrors([
              {
                messageText:
                  "End Operation Date must be larger Start Operation Date ",
              },
            ]);
            callback("error");
          } else {
            this.Change_EndLoadOperation(callback);
          }
          break;

        case 5000:
          if (this.currentDate <= this.mScheduleItem.voyage.endDischargeOperation) {
            this.showErrors([
              {
                messageText:
                  "End Discharge Date must be larger Start Discharge Date ",
              },
            ]);
            callback("error");
          } else {
            this.Change_EndDischargeOperation(callback);
          }
          break;

        case 6:
          if (this.currentDate <= this.mScheduleItem.voyage.berthDate) {
            this.showErrors([
              { messageText: "Unberth Date must be larger Berth Date " },
            ]);
            callback("error");
          } else {
            this.Change_UnBerth(callback);
          }
          break;
        case 7:
          if (this.currentDate <= this.mScheduleItem.voyage.unberthDate) {
            this.showErrors([
              { messageText: "fullaway Date must be larger Unberth Date " },
            ]);
            callback("error");
          } else {
            this.Change_Fullaway(callback);
          }
          break;
      }
    },







    ReplaceSide() {
      const me = this;
      const berthSide =
        this.mScheduleItem.voyage.side.toUpperCase() === "PORT" ? 2 : 1;
      this.showOverlay = true;
      const callback = (res) => {
         me.showOverlay = false;

        if (res.isSuccess == true) {
          const callback2 = (data) => {
            if (data != null) {
              me.mScheduleItem = data;
              me.updateComponent(me.mScheduleItem);
            }
          };
          me.mUpdateScheduleByVoyageId(me.mVoyageId, res.setScroll, callback2);
        } 
      };
      this.Change_Side(berthSide, callback);
    },

    Clear_Click() {
      this.appendValue(this.menuId, "");
      const me = this;

      const callback = (res) => {
        if (res.isSuccess == true) {
          const callback2 = (data) => {
            if (data != null) {
              me.mScheduleItem = data;
              me.updateComponent(me.mScheduleItem);
            }
            me.showOverlay = false;
            me.showOverlayClear = false;
            me.modalShowSOFSubmitDate = false;
          };
          me.mUpdateScheduleByVoyageId(me.mVoyageId, res.setScroll, callback2);
        } else {
          me.showOverlay = false;
          me.showOverlayClear = false;
        }
      };

      this.showOverlay = true;
      this.showOverlayClear = true;

      switch (this.menuId) {
        case 2:
          this.Change_Anchorage("clear", callback);
          break;
        case 3:
          this.Delete_Berth(callback);
          break;
        case 4:
          this.Delete_StartLoadOperation(callback);
          break;
        case 4000:
          this.Delete_StartDischargeOperation(callback);
          break;
        case 5:
          this.Delete_EndLoadOperation(callback);
          break;
        case 5000:
          this.Delete_EndDischargeOperation(callback);
          break;

        case 6:
          this.Delete_UnBerth(callback);
          break;
        case 7:
          this.Delete_Fullaway(callback);
      }
    },

    updateComponent(model) {

      this.mScheduleItem = model;

      this.shipSideUrl = this.getvesseltypesrcSVG(
        this.mScheduleItem.vessel.vesselTypeId,
        this.mScheduleItem.voyage.side.toUpperCase() === "PORT" ? 1 : 2
      );

      switch (model.vessel.vesselTypeId) {
        case 1: {
          this.VesselNameTransform = "translate(263.8362, 68)";
          this.ShipChange_Transform = "translate(75, -40)";
          break;
        }
        case 2: {
          this.VesselNameTransform = "translate(263.8362, 85)";
          this.ShipChange_Transform = "translate(75, -45)";
          break;
        }
        case 3: {
          this.VesselNameTransform = "translate(263.8362, 85)";
          this.ShipChange_Transform = "translate(75, -45)";
          break;
        }
        case 4: {
          this.VesselNameTransform = "translate(263.8362, 70)";
          this.ShipChange_Transform = "translate(75, -45)";
          break;
        }
        case 4000: {
          this.VesselNameTransform = "translate(263.8362, 70)";
          this.ShipChange_Transform = "translate(75, -45)";
          break;
        }
        case 5: {
          this.VesselNameTransform = "translate(263.8362, 67)";
          this.ShipChange_Transform = "translate(75, -45)";
          break;
        }
        case 5000: {
          this.VesselNameTransform = "translate(263.8362, 67)";
          this.ShipChange_Transform = "translate(75, -45)";
          break;
        }
        case 6: {
          this.VesselNameTransform = "translate(263.8362, 87)";
          this.ShipChange_Transform = "translate(75, -20)";
          break;
        }
        case 7: {
          this.VesselNameTransform = "translate(263.8362, 89)";
          this.ShipChange_Transform = "translate(75, -45)";
          break;
        }
      }

      //styleStep2_Header
      this.Step1Disable = false;
      this.activeStep = "ETA";
      this.activeStepHeaderStyle = "styleStep1_Header";

      this.stepETA_Date = moment(model.voyage.ETA).locale(this.getCurrentLocale).format("D MMMM YYYY");
      this.stepETA_Time = moment(model.voyage.ETA).format("HH:mm");
      this.stepETA_DateIcon = false;
      this.stepETA_EPT = model.voyage.EPT ?? "";

      if (model.voyage.anchorage != "") {
        this.activeStep = "anchorage";
        this.activeStepHeaderStyle = "styleStep2_Header";
        this.Step2Disable = false;
        this.stepAnchorage_Date = moment(model.voyage.anchorage).locale(this.getCurrentLocale).format("D MMMM YYYY");
        this.stepAnchorage_Time = moment(model.voyage.anchorage).format(
          "HH:mm"
        );
        this.stepAnchorage_DateIcon = false;
        this.stepAnchorage_PortTime = model.voyage.PortTime ?? "";
      } else {
        this.Step2Disable = true;
        this.anchorage = "";
        this.stepAnchorage_Date = "";
        this.stepAnchorage_Time = "";
        this.stepAnchorage_DateIcon = true;
        this.stepAnchorage_PortTime = "";
      }

      if (model.voyage.berthDate != "") {
        this.activeStep = "Berth";
        this.activeStepHeaderStyle = "styleStep3_Header";
        this.Step3Disable = false;
        this.stepBerth_Date = moment(model.voyage.berthDate).locale(this.getCurrentLocale).format("D MMMM YYYY");
        this.stepBerth_Time = moment(model.voyage.berthDate).format("HH:mm");
        this.stepBerth_DateIcon = false;
        this.stepBerth_BerthTime = model.voyage.berthTime ?? "";
      } else {
        this.Step3Disable = true;
        this.stepBerth_Date = "";
        this.stepBerth_Time = "";
        this.stepBerth_DateIcon = true;
        this.stepBerth_BerthTime = "";
      }

      if (!!model.voyage.startLoadOperation) {
        this.activeStep = "startLoadOperation";
        this.activeStepHeaderStyle = "styleStep4_Header";
        this.Step4Disable = false;
        this.stepStartLoadOperation_Date = moment(
          model.voyage.startLoadOperation
        ).locale(this.getCurrentLocale).format("D MMMM YYYY");
        this.stepStartLoadOperation_Time = moment(
          model.voyage.startLoadOperation
        ).format("HH:mm");
        this.stepStartLoadOperation_DateIcon = false;
        this.stepStartLoadOperation_OperationTime =
          model.voyage.loadOperationTime ?? "";
      } else {
        this.Step4Disable = true;
        this.stepStartLoadOperation_Date = "";
        this.stepStartLoadOperation_Time = "";
        this.stepStartLoadOperation_DateIcon = true;
        this.stepStartLoadOperation_OperationTime = "";
      }



      if (!!model.voyage.startDischargeOperation) {
        this.activeStep = "startDischargeOperation";
        this.activeStepHeaderStyle = "styleStep4000_Header";
        this.Step4000Disable = false;
        this.stepStartDischargeOperation_Date = moment(
          model.voyage.startDischargeOperation
        ).locale(this.getCurrentLocale).format("D MMMM YYYY");
        this.stepStartDischargeOperation_Time = moment(
          model.voyage.startDischargeOperation
        ).format("HH:mm");
        this.stepStartDischargeOperation_DateIcon = false;
        this.stepStartDischargeOperation_OperationTime =
          model.voyage.dischargeOperationTime ?? "";
      } else {
        this.Step4000Disable = true;
        this.stepStartDischargeOperation_Date = "";
        this.stepStartDischargeOperation_Time = "";
        this.stepStartDischargeOperation_DateIcon = true;
        this.stepStartDischargeOperation_OperationTime = "";
      }

      

      if (!!model.voyage.endDischargeOperation) {
        this.activeStep = "endDischargeOperation";
        this.activeStepHeaderStyle = "styleStep5000_Header";
        this.Step5000Disable = false;
        this.stepEndDischargeOperation_Date = moment(model.voyage.endDischargeOperation).locale(this.getCurrentLocale).format(
          "D MMMM YYYY"
        );
        this.stepEndDischargeOperation_Time = moment(model.voyage.endDischargeOperation).format(
          "HH:mm"
        );
        this.stepEndDischargeOperation_DateIcon = false;
      } else {
        this.Step5000Disable = true;
        this.stepEndDischargeOperation_Date = "";
        this.stepEndDischargeOperation_Time = "";
        this.stepEndDischargeOperation_DateIcon = true;
      }
      
      
      
      if (!!model.voyage.endLoadOperation) {
        this.activeStep = "endLoadOperation";
        this.activeStepHeaderStyle = "styleStep5_Header";
        this.Step5Disable = false;
        this.stepEndLoadOperation_Date = moment(model.voyage.endLoadOperation).locale(this.getCurrentLocale).format(
          "D MMMM YYYY"
        );
        this.stepEndLoadOperation_Time = moment(model.voyage.endLoadOperation).format(
          "HH:mm"
        );
        this.stepEndLoadOperation_DateIcon = false;
      } else {
        this.Step5Disable = true;
        this.stepEndLoadOperation_Date = "";
        this.stepEndLoadOperation_Time = "";
        this.stepEndLoadOperation_DateIcon = true;
      }

      

      if (!!model.voyage.unberthDate) {
        this.activeStep = "Unberth";
        this.activeStepHeaderStyle = "styleStep6_Header";
        this.Step6Disable = false;
        this.stepUnberth_Date = moment(model.voyage.unberthDate).locale(this.getCurrentLocale).format("D MMMM YYYY");
        this.stepUnberth_Time = moment(model.voyage.unberthDate).format(
          "HH:mm"
        );
        this.stepUnberth_DateIcon = false;
      } else {
        this.Step6Disable = true;
        this.stepUnberth_Date = "";
        this.stepUnberth_Time = "";
        this.stepUnberth_DateIcon = true;
      }

      if (!!model.voyage.fullaway) {
        this.activeStep = "fullaway";
        this.activeStepHeaderStyle = "styleStep7_Header";
        this.Step7Disable = false;
        this.stepFullaway_Date = moment(model.voyage.fullaway).locale(this.getCurrentLocale).format("D MMMM YYYY");
        this.stepFullaway_Time = moment(model.voyage.fullaway).format("HH:mm");
        this.stepFullaway_DateIcon = false;
      } else {
        this.Step7Disable = true;
        this.stepFullaway_Date = "";
        this.stepFullaway_Time = "";
        this.stepFullaway_DateIcon = true;
      }
      this.Step8Disable = false;
      this.stepETD_Date = moment(model.voyage.ETD).locale(this.getCurrentLocale).format("D MMMM YYYY");
      this.stepETD_Time = moment(model.voyage.ETD).format("HH:mm");
      this.stepETD_DateIcon = false;

      this.styleStep1_Body =
        this.Step1Disable == true ? "styleDisableBody" : "styleStep1_Body";
      this.styleStep2_Body =
        this.Step2Disable == true ? "styleDisableBody" : "styleStep2_Body";
      this.styleStep3_Body =
        this.Step3Disable == true ? "styleDisableBody" : "styleStep3_Body";
      this.styleStep4_Body =
        this.Step4Disable == true ? "styleDisableBody" : "styleStep4_Body";
      this.styleStep4000_Body =
        this.Step4000Disable == true ? "styleDisableBody" : "styleStep4000_Body";
      this.styleStep5_Body =
        this.Step5Disable == true ? "styleDisableBody" : "styleStep5_Body";
      this.styleStep5000_Body =
        this.Step5000Disable == true ? "styleDisableBody" : "styleStep5000_Body";
      this.styleStep6_Body =
        this.Step6Disable == true ? "styleDisableBody" : "styleStep6_Body";
      this.styleStep7_Body =
        this.Step7Disable == true ? "styleDisableBody" : "styleStep7_Body";
      this.styleStep8_Body =
        this.Step8Disable == true ? "styleDisableBody" : "styleStep8_Body";

      this.updateComponentDateIcon(model);
      this.RenderChart(model);
    },
    updateComponentDateIcon(model) {
      this.step2ActiveApplyClick = false;
      this.step3ActiveApplyClick = false;
      this.step4ActiveApplyClick = false;
      this.step4000ActiveApplyClick = false;
      this.step5ActiveApplyClick = false;
      this.step5000ActiveApplyClick = false;
      this.step6ActiveApplyClick = false;
      this.step7ActiveApplyClick = false;

      this.step2ActiveClearClick = false;
      this.step3ActiveClearClick = false;
      this.step4ActiveClearClick = false;
      this.step4000ActiveClearClick = false;
      this.step5ActiveClearClick = false;
      this.step5000ActiveClearClick = false;
      this.step6ActiveClearClick = false;
      this.step7ActiveClearClick = false;

      if (model.voyage.anchorage == "") {
        this.step2ActiveApplyClick = true;
        this.step2ActiveClearClick = false;
      }

      if (model.voyage.anchorage != "" && model.voyage.berthDate == "") {
        this.step2ActiveApplyClick = true;
        this.step2ActiveClearClick = true;

        this.step3ActiveApplyClick = true;
        this.step3ActiveClearClick = false;
      }

      if (
        !!model.voyage.startLoadOperation &&
        !model.voyage.endLoadOperation
      ) {
        this.step4ActiveApplyClick = true;
        this.step4ActiveClearClick = true;

        this.step5ActiveApplyClick = true;
        this.step5ActiveClearClick = false;
      }


      if (
        !!model.voyage.startDischargeOperation &&
        !model.voyage.endDischargeOperation
      ) {
        this.step4000ActiveApplyClick = true;
        this.step40000ActiveClearClick = true;

        this.step5000ActiveApplyClick = true;
        this.step5000ActiveClearClick = false;
      }

      if (
        !!model.voyage.berthDate &&
        !model.voyage.startLoadOperation &&
        !model.voyage.unberthDate
      ) {
        this.step3ActiveApplyClick = true;
        this.step3ActiveClearClick = true;

        this.step4ActiveApplyClick = true;
        this.step4ActiveClearClick = false;

        this.step6ActiveApplyClick = true;
        this.step6ActiveClearClick = false;
      }

      if (
        !!model.voyage.berthDate &&
        !model.voyage.startDischargeOperation &&
        !model.voyage.unberthDate
      ) {
        this.step3ActiveApplyClick = true;
        this.step3ActiveClearClick = true;

        this.step4000ActiveApplyClick = true;
        this.step4000ActiveClearClick = false;

        this.step6ActiveApplyClick = true;
        this.step6ActiveClearClick = false;
      }

      if (!!model.voyage.endLoadOperation && !model.voyage.unberthDate) {
        this.step5ActiveApplyClick = true;
        this.step5ActiveClearClick = true;

        this.step6ActiveApplyClick = true;
        this.step6ActiveClearClick = false;
      }

      if (!!model.voyage.endDischargeOperation && !model.voyage.unberthDate) {
        this.step5000ActiveApplyClick = true;
        this.step5000ActiveClearClick = true;

        this.step6ActiveApplyClick = true;
        this.step6ActiveClearClick = false;
      }

      if (!!model.voyage.startDischargeOperation && !model.voyage.unberthDate && !model.voyage.endDischargeOperation) {
        this.step4000ActiveApplyClick = true;
        this.step4000ActiveClearClick = true;

        this.step6ActiveApplyClick = true;
        this.step6ActiveClearClick = false;
      }

      if (!!model.voyage.unberthDate && !model.voyage.fullaway) {
        this.step6ActiveApplyClick = true;
        this.step6ActiveClearClick = true;
        this.step7ActiveApplyClick = true;
        this.step7ActiveClearClick = false;
      }

      if (!!model.voyage.fullaway) {
        this.step7ActiveApplyClick = true;
        this.step7ActiveClearClick = true;
      }

      // isConcept==false && isReadOnly==false

      if (this.isConcept == true || this.isReadOnly == true) {
        this.step1ActiveApplyClick = false;
        this.step2ActiveApplyClick = false;
        this.step3ActiveApplyClick = false;
        this.step4ActiveApplyClick = false;
        this.step4000ActiveApplyClick = false;
        this.step5ActiveApplyClick = false;
        this.step5000ActiveApplyClick = false;
        this.step6ActiveApplyClick = false;
        this.step6000ActiveApplyClick = false;
        this.step7ActiveApplyClick = false;
      }
    },

    RenderChart(model) {
      this.EnableContainerShipChart = false;
      if (model.vessel.vesselType == "ContainerShip") {
        const D20 = model.voyageDetails.D20;
        const D40 = model.voyageDetails.D40;
        const D45 = model.voyageDetails.D45;
        const DBox = D20 + D40 + D45;
        const DTEU = D20 + 2 * (D40 + D45);

        const L20 = model.voyageDetails.L20;
        const L40 = model.voyageDetails.L40;
        const L45 = model.voyageDetails.L45;
        const LBox = L20 + L40 + L45;
        const LTEU = L20 + 2 * (L40 + L45);

        const R20 = model.voyageDetails.R20;
        const R40 = model.voyageDetails.R40;
        const R45 = model.voyageDetails.R45;
        const RBox = R20 + R40 + R45;
        const RTEU = R20 + 2 * (R40 + R45);

        if (DBox + LBox + RBox > 0) {
          this.EnableContainerShipChart = true;
          this.ChartSeries = [
            {
              name: "20''",
              data: [D20, L20, R20],
            },
            {
              name: "40''",
              data: [D40, L40, R40],
            },
            {
              name: "45''",
              data: [D45, L45, R45],
            },
            {
              name: "Box",
              data: [DBox, LBox, RBox],
            },
            {
              name: "TEU",
              data: [DTEU, LTEU, RTEU],
            },
          ];
        }
      }
    },

    activeClearButton(menuid) {
      switch (menuid) {
        case 2: {
          return this.step2ActiveClearClick;
        }
        case 3: {
          return this.step3ActiveClearClick;
        }
        case 4: {
          return this.step4ActiveClearClick;
        }
        case 4000: {
          return this.step4000ActiveClearClick;
        }
        case 5: {
          return this.step5ActiveClearClick;
        }
        case 5000: {
          return this.step5000ActiveClearClick;
        }
        case 6: {
          return this.step6ActiveClearClick;
        }
        case 7: {
          return this.step7ActiveClearClick;
        }
      }
    },

    refreshData(newModel) {
      //
      this.mScheduleItem = newModel;
      this.mVoyageId = newModel.voyage.voyageId;
      this.mConceptId = newModel.ConceptId;
      // this.isConcept = this.mScheduleItem.isConcept;
      this.deleteTitle =
        this.isConcept == true ? "delete concept" : "delete plan";
      this.updateComponent(this.mScheduleItem);
    },

    Change_Anchorage(mode, callback) {
      const state = {
        VoyageId: this.mVoyageId,
        anchorageInDate:
          mode === "clear"
            ? null
            : moment(this.currentDate).format("YYYY-MM-DDTHH:mm:ss"),
      };
      this.showOverlay = true;
      this.$store.dispatch(Update_VoyageSOF_AnchorageIn, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          // let setToScroll = false;
          // if (this.currentOldDate != this.currentDate) {
          //   setToScroll = true;
          // }

          callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },

    // ReplaceSide999999() {
    //   const me = this;
    //   const berthSide =
    //     this.mScheduleItem.voyage.side.toUpperCase() === "PORT" ? 2 : 1;
    //   this.showOverlay = true;
    //   const callback = (data) => {
    //     me.showOverlay = false;

    //     if (data == "ok") {
    //       me.mScheduleItem = me.mUpdateScheduleBerthSideByVoyageId(
    //         me.mVoyageId,
    //         berthSide
    //       );
    //       me.updateComponent(me.mScheduleItem);
    //     }
    //   };
    //   this.Change_Side(berthSide, callback);
    // },

    Change_Side(berthSide, callback) {
      this.showOverlay = true;

      let state = {
        VoyageId: this.mVoyageId,
        berthSide: berthSide,
        rowVersion: this.mScheduleItem.rowVersion,
      };

      let fnAdrees = Update_BerthSideByVoyageId;
      if (this.isConcept) {
        state = {
          VoyageId: this.mVoyageId,
          ConceptId: this.mConceptId,
          berthSide: berthSide,
          rowVersion: this.mScheduleItem.rowVersion,
        };
        fnAdrees = Update_ConceptBerthSideByVoyageId;
      }

      this.$store.dispatch(fnAdrees, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          // callback("error");
           callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          // callback("ok");
           callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },

    Change_Berth(callback) {
      let VoyageBerthId = 0;
      if (this.mScheduleItem.voyage.anchorage != "") {
        VoyageBerthId =
          this.mScheduleItem.IsPlan == false ? this.mScheduleItem.id : 0;

        let state = {
          VoyageId: this.mVoyageId,
          berthDate: moment(this.currentDate).format("YYYY-MM-DDTHH:mm:ss"),
          endBollardId: Number(this.mScheduleItem.endBollardId),
          startBollardId: Number(this.mScheduleItem.startBollardId),
          berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
          rowVersion: this.mScheduleItem.rowVersion,
          VoyageBerthId: VoyageBerthId,
        };
        this.showOverlay = true;
        this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
          this.showOverlay = false;
          const errors = this.getVoyageSOFErrors;
          if (errors.length > 0) {
            this.showErrors(errors);
            callback({ isSuccess: false, message: "error", setScroll: false });
          } else {
            let setToScroll = false;
            if (this.currentOldDate != this.currentDate) {
              setToScroll = true;
            }
            callback({
              isSuccess: true,
              message: "ok",
              setScroll: setToScroll,
            });
          }
        });
      }
    },
    Change_UnBerth(callback) {
      
      let startLoadOperation = null;
      if (!!this.mScheduleItem.voyage.startLoadOperation) {
        startLoadOperation = moment(
          this.mScheduleItem.voyage.startLoadOperation
        ).format("YYYY-MM-DDTHH:mm:ss");
      }

      let endLoadOperation = null;
      if (!!this.mScheduleItem.voyage.endLoadOperation) {
        endLoadOperation = moment(this.mScheduleItem.voyage.endLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let startDischargeOperation = null;
      if (!!this.mScheduleItem.voyage.startDischargeOperation) {
        startDischargeOperation = moment(this.mScheduleItem.voyage.startDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let endDischargeOperation = null;
      if (!!this.mScheduleItem.voyage.endDischargeOperation) {
        endDischargeOperation = moment(this.mScheduleItem.voyage.endDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      

      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
        unberthDate: moment(this.currentDate).format("YYYY-MM-DDTHH:mm:ss"),
        startLoadOperation,
        endLoadOperation,
        startDischargeOperation,
        endDischargeOperation,
        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          let setToScroll = false;
          if (this.currentOldDate != this.currentDate) {
            setToScroll = true;
          }
          callback({ isSuccess: true, message: "ok", setScroll: setToScroll });
        }
      });
    },

    Change_StartLoadOperation(callback) {
      let unberthDate = null;
      if (this.mScheduleItem.voyage.unberthDate != "") {
        unberthDate = moment(this.mScheduleItem.voyage.unberthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let endLoadOperation = null;
      if (!!this.mScheduleItem.voyage.endLoadOperation) {
        endLoadOperation = moment(this.mScheduleItem.voyage.endLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let startDischargeOperation = null;
      if (!!this.mScheduleItem.voyage.startDischargeOperation) {
        startDischargeOperation = moment(this.mScheduleItem.voyage.startDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let endDischargeOperation = null;
      if (!!this.mScheduleItem.voyage.endDischargeOperation) {
        endDischargeOperation = moment(this.mScheduleItem.voyage.endDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }
      
      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
        unberthDate: unberthDate,
        startLoadOperation: moment(this.currentDate).format("YYYY-MM-DDTHH:mm:ss"),
        endLoadOperation,
        startDischargeOperation,
        endDischargeOperation,
        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },


    Change_StartDischargeOperation(callback) {
      let unberthDate = null;
      if (this.mScheduleItem.voyage.unberthDate != "") {
        unberthDate = moment(this.mScheduleItem.voyage.unberthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let endDischargeOperation = null;
      if (!!this.mScheduleItem.voyage.endDischargeOperation) {
        endDischargeOperation = moment(this.mScheduleItem.voyage.endDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let startLoadOperation = null;
      if (!!this.mScheduleItem.voyage.startLoadOperation) {
        startLoadOperation = moment(this.mScheduleItem.voyage.startLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let endLoadOperation = null;
      if (!!this.mScheduleItem.voyage.endLoadOperation) {
        endLoadOperation = moment(this.mScheduleItem.voyage.endLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
        unberthDate: unberthDate,
        startLoadOperation: startLoadOperation,
        endLoadOperation: endLoadOperation,
        startDischargeOperation: moment(this.currentDate).format("YYYY-MM-DDTHH:mm:ss"),
        endDischargeOperation: endDischargeOperation,
        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },

    Change_EndLoadOperation(callback) {
      let unberthDate = null;
      if (!!this.mScheduleItem.voyage.unberthDate) {
        unberthDate = moment(this.mScheduleItem.voyage.unberthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }


      let startDischargeOperation = null;
      if (!!this.mScheduleItem.voyage.startDischargeOperation) {
        startDischargeOperation = moment(this.mScheduleItem.voyage.startDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let endDischargeOperation = null;
      if (!!this.mScheduleItem.voyage.endDischargeOperation) {
        endDischargeOperation = moment(this.mScheduleItem.voyage.endDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
        unberthDate: unberthDate,
        startLoadOperation: moment(this.mScheduleItem.voyage.startLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
        startDischargeOperation,
        endDischargeOperation,
        endLoadOperation: moment(this.currentDate).format("YYYY-MM-DDTHH:mm:ss"),
        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },

    Change_EndDischargeOperation(callback) {
      let unberthDate = null;
      if (!!this.mScheduleItem.voyage.unberthDate) {
        unberthDate = moment(this.mScheduleItem.voyage.unberthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let startLoadOperation = null;
      if (!!this.mScheduleItem.voyage.startLoadOperation) {
        startLoadOperation = moment(this.mScheduleItem.voyage.startLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let endLoadOperation = null;
      if (!!this.mScheduleItem.voyage.endLoadOperation) {
        endLoadOperation = moment(this.mScheduleItem.voyage.endLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let startDischargeOperation = null;
      if (!!this.mScheduleItem.voyage.startDischargeOperation) {
        startDischargeOperation = moment(this.mScheduleItem.voyage.startDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
        unberthDate: unberthDate,
        startDischargeOperation: moment(this.mScheduleItem.voyage.startDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
        endDischargeOperation: moment(this.currentDate).format("YYYY-MM-DDTHH:mm:ss"),
        startLoadOperation,
        endLoadOperation,
        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },

    Delete_Planfn(callback) {
      const state = {
        id: this.mScheduleItem.id,
        rowVersion: this.mScheduleItem.rowVersion,
      };
      this.showOverlay = true;
      this.$store.dispatch(Delete_VoyageSOF_Plan, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
           callback({ isSuccess: false, message: "error" });
        } else {
           callback({ isSuccess: true, message: "ok" });
        }
      });
    },

    Delete_Conceptfn(callback) {
      const state = {
        conceptItemId: this.mScheduleItem.id,
        rowVersion: this.mScheduleItem.rowVersion,
      };

      this.showOverlay = true;
      this.$store.dispatch(Delete_ConceptItem, state).then(() => {
        this.showOverlay = false;
        const errors = this.getConceptChartErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
           callback({ isSuccess: false, message: "error" });
        } else {
           callback({ isSuccess: true, message: "ok" });
        }
      });
    },

    Delete_Berth(callback) {
      const state = {
        id: this.mScheduleItem.id,
        rowVersion: this.mScheduleItem.rowVersion,
      };
      this.showOverlay = true;
      this.$store.dispatch(Delete_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: true });
        }
      });
    },
    Delete_UnBerth(callback) {
      let startLoadOperation = null;
      let startDischargeOperation = null;
      if (this.mScheduleItem.voyage.startLoadOperation != "") {
        startLoadOperation = moment(
          this.mScheduleItem.voyage.startLoadOperation
        ).format("YYYY-MM-DDTHH:mm:ss");
      }
      if (this.mScheduleItem.voyage.startDischargeOperation != "") {
        startDischargeOperation = moment(
          this.mScheduleItem.voyage.startDischargeOperation
        ).format("YYYY-MM-DDTHH:mm:ss");
      }
      let endLoadOperation = null;
      if (this.mScheduleItem.voyage.endLoadOperation != "") {
        endLoadOperation = moment(this.mScheduleItem.voyage.endLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }
      let endDischargeOperation = null;
      if (this.mScheduleItem.voyage.endDischargeOperation != "") {
        endDischargeOperation = moment(this.mScheduleItem.voyage.endDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
        unberthDate: null,
        startLoadOperation: startLoadOperation,
        startDischargeOperation: startLoadOperation,
        endLoadOperation: endLoadOperation,
        endDischargeOperation: endLoadOperation,

        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: true });
        }
      });
    },

    Delete_StartLoadOperation(callback) {
      let unberthDate = null;
      if (this.mScheduleItem.voyage.unberthDate != "") {
        unberthDate = moment(this.mScheduleItem.voyage.unberthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      
      let startDischargeOperation = null;
      if (this.mScheduleItem.voyage.startDischargeOperation != "") {
        startDischargeOperation = moment(this.mScheduleItem.voyage.startDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      
      let endDischargeOperation = null;
      if (this.mScheduleItem.voyage.endDischargeOperation != "") {
        endDischargeOperation = moment(this.mScheduleItem.voyage.endDischargeOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),

        unberthDate: unberthDate,
        startLoadOperation: null,
        startDischargeOperation,
        endDischargeOperation,
        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },

    Delete_StartDischargeOperation(callback) {
      let unberthDate = null;
      if (this.mScheduleItem.voyage.unberthDate != "") {
        unberthDate = moment(this.mScheduleItem.voyage.unberthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let endLoadOperation = null;
      if (this.mScheduleItem.voyage.endLoadOperation != "") {
        endLoadOperation = moment(this.mScheduleItem.voyage.endLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let startLoadOperation = null;
      if (this.mScheduleItem.voyage.startLoadOperation != "") {
        startLoadOperation = moment(this.mScheduleItem.voyage.startLoadOperation).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }

      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),

        unberthDate: unberthDate,
        startLoadOperation,
        endLoadOperation,
        startDischargeOperation: null,
        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },

    Delete_EndLoadOperation(callback) {
      let unberthDate = null;
      if (this.mScheduleItem.voyage.unberthDate != "") {
        unberthDate = moment(this.mScheduleItem.voyage.unberthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }
      let startLoadOperation = null;
      if (this.mScheduleItem.voyage.startLoadOperation != "") {
        startLoadOperation = moment(
          this.mScheduleItem.voyage.startLoadOperation
        ).format("YYYY-MM-DDTHH:mm:ss");
      }
      let startDischargeOperation = null;
      if (this.mScheduleItem.voyage.startDischargeOperation != "") {
        startDischargeOperation = moment(
          this.mScheduleItem.voyage.startDischargeOperation
        ).format("YYYY-MM-DDTHH:mm:ss");
      }
      let endDischargeOperation = null;
      if (this.mScheduleItem.voyage.endDischargeOperation != "") {
        endDischargeOperation = moment(
          this.mScheduleItem.voyage.endDischargeOperation
        ).format("YYYY-MM-DDTHH:mm:ss");
      }

      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),

        unberthDate: unberthDate,
        startLoadOperation: startLoadOperation,
        endLoadOperation: null,
        startDischargeOperation,
        endDischargeOperation,
        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },

    Delete_EndDischargeOperation(callback) {
      let unberthDate = null;
      if (this.mScheduleItem.voyage.unberthDate != "") {
        unberthDate = moment(this.mScheduleItem.voyage.unberthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        );
      }
      let startDischargeOperation = null;
      if (this.mScheduleItem.voyage.startDischargeOperation != "") {
        startDischargeOperation = moment(
          this.mScheduleItem.voyage.startDischargeOperation
        ).format("YYYY-MM-DDTHH:mm:ss");
      }

      let startLoadOperation = null;
      if (this.mScheduleItem.voyage.startLoadOperation != "") {
        startLoadOperation = moment(
          this.mScheduleItem.voyage.startLoadOperation
        ).format("YYYY-MM-DDTHH:mm:ss");
      }

      let endLoadOperation = null;
      if (this.mScheduleItem.voyage.endLoadOperation != "") {
        endLoadOperation = moment(
          this.mScheduleItem.voyage.endLoadOperation
        ).format("YYYY-MM-DDTHH:mm:ss");
      }

      let state = {
        VoyageId: this.mVoyageId,
        berthDate: moment(this.mScheduleItem.voyage.berthDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),

        unberthDate: unberthDate,
        startLoadOperation: startLoadOperation,
        startDischargeOperation: startDischargeOperation,
        endLoadOperation,
        endDischargeOperation: null,
        endBollardId: Number(this.mScheduleItem.endBollardId),
        startBollardId: Number(this.mScheduleItem.startBollardId),
        berthSide: this.mScheduleItem.voyage.side === "PORT" ? 1 : 2,
        rowVersion: this.mScheduleItem.rowVersion,
        VoyageBerthId: this.mScheduleItem.id,
      };
      this.showOverlay = true;
      this.$store.dispatch(AddOrUpdate_VoyageSOF_Berth, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: false });
        }
      });
    },

    Change_Fullaway(callback) {
      const state = {
        VoyageId: this.mVoyageId,
        anchorageOutDate: moment(this.currentDate).format(
          "YYYY-MM-DDTHH:mm:ss"
        ),
      };
      this.showOverlay = true;
      this.$store.dispatch(Update_VoyageSOF_AnchorageOut, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          let setToScroll = false;
          if (this.currentOldDate != this.currentDate) {
            setToScroll = true;
          }
          callback({ isSuccess: true, message: "ok", setScroll: setToScroll });
        }
      });
    },
    Delete_Fullaway(callback) {
      const state = {
        VoyageId: this.mVoyageId,
        anchorageOutDate: null,
      };
      this.showOverlay = true;
      this.$store.dispatch(Update_VoyageSOF_AnchorageOut, state).then(() => {
        this.showOverlay = false;
        const errors = this.getVoyageSOFErrors;
        if (errors.length > 0) {
          this.showErrors(errors);
          callback({ isSuccess: false, message: "error", setScroll: false });
        } else {
          callback({ isSuccess: true, message: "ok", setScroll: true });
        }
      });
    },
  },

  validations: {
    currentDate: { required },
  },
};
</script>

<style scoped>
.enbaled {
  cursor: pointer;
  color: green;
  font-weight: 900;
}
.filterdate {
  width: 100%;
}

/* .navi-item {
  background-color: #ffff;
} */

#CSide:hover {
  fill: #425671;
}
.gSelect:hover {
  fill: skyblue;
}
.timestyle {
  font-size: 0.7em;
  font-weight: bold;
  alignment-baseline: middle;
  text-anchor: middle;
}
</style>
<style>
.mx-datepicker-popup {
  z-index: 50000 !important;
}
</style>

<style type="text/css" scope>
.stA0 {
  fill: none;
}
.styleStepFont10 {
  fill: #ffffff;
  font-size: 10px;
}
.styleStepFont9 {
  fill: #ffffff;
  font-size: 9px;
}
.styleStepFont8 {
  fill: #ffffff;
  font-size: 8px;
}

/* Disable */
.styleDisableHeader,
.styleDisableFooter {
  fill: #747373;
}
.styleDisableBody {
  fill: #989696;
}

.styleStep_Body_hover {
  opacity: 1 !important;
}

/* Step1 */
.styleStep1_Header {
  fill: #0b467e;
}
.styleStep1_Body {
  fill: #1371c9;
  opacity: 0.8;
}

.styleStep1DisableFooter_hover {
  fill: #0b467e;
}

/* Step2 */
.styleStep2_Header {
  fill: #225d64;
}
.styleStep2_Body {
  fill: #2e7780;
  opacity: 0.8;
}
.styleStep2DisableFooter_hover {
  fill: #225d64;
}

/* Step3 */
.styleStep3_Header {
  fill: #0e6b3b;
}
.styleStep3_Body {
  fill: #1ea35e;
  opacity: 0.8;
}
.styleStep3DisableFooter_hover {
  fill: #0e6b3b;
}

/* Step4 */
.styleStep4_Header {
  fill: #9c1622;
}
.styleStep4_Body {
  fill: #d12736;
  opacity: 0.8;
}

.styleStep4000_Header {
  fill: #031650;
  opacity: 0.8;
}
.styleStep4000_Body {
  fill: #2752d1;
  opacity: 0.8;
}
.styleStep4DisableFooter_hover {
  fill: #9c1622;
}

/* Step5 */
.styleStep5_Header {
  fill: #8b1d79;
}
.styleStep5_Body {
  fill: #9a2c87;
  opacity: 0.8;
}
.styleStep5000_Body {
  fill: #2c9a98;
  opacity: 0.8;
}
.styleStep5000_Header {
  fill: #2c9a98;
}

/* Step6 */
.styleStep6_Header {
  fill: #b43c14;
}
.styleStep6_Body {
  fill: #d8562c;
  opacity: 0.8;
}

/* Step7 */
.styleStep7_Header {
  fill: #ac7817;
}
.styleStep7_Body {
  fill: #fab637;
  opacity: 0.8;
}

/* Step8 */
.styleStep8_Header {
  fill: #0a4883;
}
.styleStep8_Body {
  fill: #1765ae;
  opacity: 0.8;
}

.st0A {
  fill: #747373;
  stroke: #747373;
  stroke-miterlimit: 10;
}
.st1A {
  fill: none;
  stroke: #747373;
  stroke-width: 2;
  stroke-miterlimit: 10;
}
.st2A {
  fill: none;
}

/* new */
.styleVesselName {
  fill: #ffffff;
  font-size: 10px;
}

.styleBerthName {
  font-size: 10px;
  font-weight: bold;
  fill: #6e6c6c;
}
.styleBollardName {
  font-size: 9px;
  font-weight: bold;
  fill: #6e6c6c;
}

.styleLOA {
  font-size: 8px;
  font-weight: bold;
  fill: #6e6c6c;
}
.styleDraft {
  font-size: 8px;
  font-weight: bold;
  fill: #6e6c6c;
}
.styleVesselInfo {
  font-size: 9px;
  font-weight: bold;
  color: #4d4d4d;
}
.styleVesselInfoLegend {
  color: #1e7ca8;
  font-weight: bold;
}
.styleDateIcon {
  fill: #3a3a3a;
}
.styleDateIcon:hover {
  fill: #ffa800;
}

.styleShipChange_Direction {
  fill: #2c86db;
}
.styleShipChange_Direction:hover {
  fill: #ffa800;
}
/* end new */

.stV0 {
  fill: #4d4d4d;
}
.stV1 {
  fill: #ffffff;
}
.stV2 {
  fill: #4e4d4d;
}

.stV5 {
  fill: #1d1d1b;
}

.stV35 {
  fill: none;
}

.stV38 {
  fill: none;
  stroke: #1d1d1b;
  stroke-miterlimit: 10;
}
.stV39 {
  fill: none;
  stroke: #1d1d1b;
  stroke-miterlimit: 10;
  stroke-dasharray: 0.9953, 0.9953;
}

.stV41 {
  fill: none;
  stroke: #1d1d1b;
  stroke-miterlimit: 10;
  stroke-dasharray: 0.885, 0.885;
}

.Mybtn-svg-BerthSide {
  max-height: 22px !important;
  max-width: 32px;
  line-height: 4px !important;
}

.Mybtn-svg-BerthSide > i {
  font-size: 14px !important;
  line-height: 6px !important;
}

.Mybtn-svg-Delete {
  max-height: 22px !important;
  max-width: 32px;
  line-height: 4px !important;
}

.Mybtn-svg-Delete > i {
  font-size: 14px !important;
  line-height: 6px !important;
}
</style>
